export const m_cn = {
  bindCompany: {
    tip: '请完善您的信息，您可以在JCtrans上解锁更多服务，如提供咨询、报价和参加会议',
    selectCity: '选择公司所在城市',
    selectCityPH: '请输入公司所在城市',
    compNameCn: '公司中文名称',
    compNameCnPH: '请输入所在公司名称',
    compNameEn: '公司英文名称',
    compNameEnPH: '请输入所在公司英文名称',
    industry: '行业类型',
    phone: '手机号',
    phonePH: '请输入正确手机号码',
    verifyCode: '验证码',
    verifyCodeCellPH: '请输入手机验证码',
    verifyCodeEmailPH: '请输入邮箱验证码',
    email: '邮箱',
    obtain: '发送验证码',
    confirm: '确认提交',
    ignore: '暂不确认',
    select_city: '请选择公司所在城市',
    compNameCn_p: '请输入公司中文名',
    compNameEn_p: '请输入公司英文名',
    invalid_characters: '请输入有效信息',
    choose_category: '请选择企业性质',
    emailRules: '邮箱格式错误',
    verify_email_address_msg_correct_qq: '当前不支持qq邮箱，请更换其他邮箱',
    area_code: '请选择',
    mobileRules: '手机号格式错误',
    verify_phone_code: '请输入手机验证码',
    verify_email_code: '请输入邮箱验证码',
    company_exists: '公司名已存在',
    add_success: '操作成功',
  },
  signIn_or_signUp: '登录/注册',
  signIn: '登 录',
  signInwait: '登 录 中...',
  form_Cancel: '取消',
  form_Confirm: '确定',
  form_Close: '关闭',
  form_Email: '邮箱',
  form_Create: '提 交',
  form_Create_z: '提 交 中...',
  name: '名称',
  form_yes: '完成',
  signIn_overTime: '该账号已在别处登录，是否重新登录？',
  // login
  // footerText: 'JCtrans版权所有2000-2022 京ICP证060822号',
  footerText_1: '© ',
  footerText_2: ' jctrans.com All rights reserved. ',
  login_kh: '欢迎来到',
  login_kh2: 'JCtrans',
  login_introduce1: ' 即使您有稳定的货运代理，',
  login_introduce2: '您仍然可以考虑增加一个专业的新选择！',
  login_title: '',
  login_title2: '链全球商机 帮货代盈利',
  login_small_title: '全球超200个国家、海量货代资源触手可得！',
  login_SIGN: '立即注册',
  login_zh: '用户名',
  login_zh_new: '用户名/邮箱/手机号',
  login_mm: '密码',
  login_CodeCn_no: '请输入验证码',
  login_Code: '验证码',
  login_Code_placeholder: '输入计算结果',
  login_Code2: '验证码',
  login_Code_sp: '请输入4位数字验证码',
  login_Forget: '忘记密码',
  login_Remember: '30天自动登录',
  login_zh_p: '请输入账号/手机号/邮箱',
  login_mm_p: '请输入密码',
  login_Code_p: '请输入验证码',
  login_Code_m: '请输入4位数字验证码',
  login_LoggedIn: '当前账号已在线，是否继续登录？',
  login_Tips: '提示',
  login_customerService_Tips: '提示',
  login_customerService_detail: '请选择您想分配当前账号为客服人员的平台',
  login_fail2: '二次登陆失败',
  login_label_user: '请输入账号/手机号/邮箱',
  login_label_password: '请输入密码',
  login_register: '没有账户？',
  login_passwd: '账号登录',
  login_verify_code: '验证码登录',
  login_getCode_again: '请点击获取验证码',
  login_title_new: '欢迎回到JCtrans',
  // 扫码登录
  login_wx_tip: '微信扫码登录',
  login_wx_success: '扫码成功',
  login_wx_again: '重新扫码',
  login_wx_scan: '微信扫码登录/注册JCtrans',
  login_account_passport: '账号密码',
  login_account_passport_tip: '账号/验证码登录',
  login_code_expired: '二维码已过期',
  login_choose_title: '请选择是否已有JCtrans账号',
  login_choose_tips:
    '若已有JCtrans账号，可直接与微信绑定；若没有JCtrans账号，请先注册',
  login_to_register: '没有账号，立即注册',
  login_to_login: '已有JCtrans账号',
  login_bind_title: '登录并绑定微信',
  login_bind_tips: '绑定后，可通过微信扫码登录，方便快捷',
  login_bind_submit: '登录并绑定',
  login_account_paaport: '账号密码',
  login_account: '账号',

  forgetpass_zy1: '重置密码',
  forgetpass_zy2: '请输入您的用户名用于重置密码',
  forgetpass_kf: '联系客服',
  forgetpass_yhm: '登录账号',
  forgetpass_yhm_p: '请输入账号/手机号/邮箱',
  forgetpass_Email: '邮箱',
  forgetpass_Email_p: '请输入邮箱',
  forgetpass_hq1: '获取验证码',
  forgetpass_hq2: '重新获取(',
  forgetpass_hq3: ')',
  forgetpass_hq4: '获取手机号验证码',
  forgetpass_hq5: '立即认证',
  forgetpass_wj1: '用户名不能为空，请重新输入',
  forgetpass_wj2: '6-30个字符，包括字母或数字',
  forgetpass_wj3: '6-30个字符，包括字母或数字',
  forgetpass_wj4: '用户名称应为数字和英文字母组成',
  forgetpass_wj5: '当前账号不存在',
  forgetpass_wj6: '密码不能为空，请重新输入',
  forgetpass_wj7: '密码为6-20位字符',
  forgetpass_wj8: '密码为6-20位字符',
  forgetpass_wj9: '请输入6-20位字符，包含字母、数字和符号',
  forgetpass_wj10: '请输入您的邮箱',
  forgetpass_wj11: '请输入公司名称',
  forgetpass_wj12: '注册公司名不能有中文',
  forgetpass_wj13: '请输入公司名称',
  forgetpass_wj14: '注册公司名格式错误',
  forgetpass_wj15: '请输入公司名称',
  forgetpass_wj16: '请输入您的姓名',
  forgetpass_wj17: '姓名不能有中文',
  forgetpass_wj18: '姓名格式错误',
  forgetpass_wj19: '请输入您的姓名',
  zc_cf: '重新发送',
  forgetpass_NewPassword: '设置密码',
  forgetpass_New_p: '请输入密码',
  forgetpass_Confirm: '确认密码',
  forgetpass_Confirm_p: '请输入确认密码',
  forgetpass_Phone: '手机',
  forgetpass_Phone_p: '请输入您的手机号',
  forgetpass_PhoneCode: '短信验证码',
  forgetpass_PhoneCode_p: '请输入4位数字验证码',
  forgetpass_service: '人工客服',
  forgetpass_service1: '找回密码遇到问题？',
  forgetpass_service2: '进行人工处理',
  forgetpass_service_lx: '联系客服',
  forgetpass_Contact: '联系',
  forgetpass_Customer: '联系客服',
  forgetpass_Customer1: '当前账号没有手机号和邮箱，无法验证，请直接联系客服。',
  login_Back: '上一步',
  login_Next: '下一步',
  login_zqCode: '验证码错误，请重新输入',
  login_zk: '展开 ∨',
  login_sq: '收起 ∧',
  login_mm_atypism: '密码不一致，请确保您的密码一致',
  login_mmok: '密码重置成功',
  forgetpass_5f:
    '验证码将会发送到您的邮箱，5分钟后失效。请不要与任何人分享您的验证码。',
  forgetpass_5fs:
    '验证码将会发送到您的手机，5分钟后失效。请不要与任何人分享您的验证码。',
  Password_6_20: '请输入6-20位字符，包含字母、数字和符号',
  Password_word: '请输入6-20位字符，包含字母、数字和符号',
  Password_number: '请输入6-20位字符，包含字母、数字和符号',
  // register
  register_Username_p: '用户名不能为空，请重新输入',
  register_step1: '创建账号',
  register_step2: '设置信息',
  register_step3: '注册完成',
  register_Title: '新用户注册',
  register_UserName: '用户名',
  register_Password: '设置密码',
  register_Confirm: '确认密码',
  register_Name: '您的名称',
  register_Email: '邮箱',
  register_Company: '公司英文名称',
  register_checkCompanyName_alert_title: '提示',
  register_checkCompanyName_alert:
    '当前公司已存在，请确认公司名称或联系客服进行处理。',
  register_Country: '国家/地区',
  register_Location: '选择公司所在城市',
  register_City: '城市',
  register_MobileCode: '短信验证码',
  register_IndustrySector: '行业类型',
  register_RegistrationInformation: '注册信息',
  register_Way: '选择注册方式',
  register_Explain: '可直接使用邮箱或者手机号码作为登录账号进行系统登录',
  register_Set_Password: '设置登录密码',
  register_I_Green: '我已阅读并同意',

  register_UserName_p: '6-30位字符，包含字母和数字',
  register_Password_p: '请输入6-20位字符，包含字母、数字和符号',
  register_Confirm_p: '请输入6-20位字符，包含字母、数字和符号',
  register_Name_p: '请输入您的名称',
  register_Email_p: '例：Email@jctrans.net',
  register_Email_p2: '请输入您的邮箱',
  register_Email_p3: '请输入企业邮箱，个人邮箱可能造成邮件丢失',
  register_Email_p4: '请输入您的企业邮箱，暂不支持QQ邮箱',
  register_Email_p5: '请输入正确的公司邮箱',
  register_Email_desc: '公司邮箱商务合作时更专业',
  register_Address_p1: '请从下拉选项中搜索选择您的公司国家/地区',
  register_Address_p2: '请从下拉选项中搜索选择您的公司城市',
  register_Company_p: '请输入公司名称全名',
  register_Country_p: '请选择国家/地区',
  register_Country_sp: '请选择所在地',
  register_Country_sp2: '请输入公司所在城市',
  register_City_p: '请选择城市',
  register_City_sp: '请选择城市',
  register_see1: '请查看',
  register_see2: '来自 JCtrans 的电子邮件，用以完成您的账户激活',
  register_verification: '正在等待您进行验证',
  register_InitiateValidation: '提交验证',
  register_again: '验证码错误，请重新输入',
  register_no_mail: '没有收到我们的电子邮件？',
  register_skip: '跳过',
  register_fault: '如果您尚未收到我们的电子邮件，请尝试下述的步骤来排除故障:',
  register_fault1:
    '1. 请检查您的垃圾邮件和已删除邮件目录下是否有来自 info@jctrans.net 的邮件。有时电子邮件会被您的电子邮箱服务商错误的识别为垃圾邮件。',
  register_fault2:
    '2. 稍等片刻。有时接收电子邮件缓慢，需要花几分钟时间来接收电子邮件。',
  register_fault3: '3. 如果您依然无法找到我们的邮件，请联系平台客服人员。',
  register_valid_mail: '请输入有效的邮箱地址',
  kq_isSearch: '公司查询中',
  kq_placeholder: '请输入您的公司中文名称',
  kq_onceSearch: '请输入公司名称',
  kq_null: '无匹配公司，请重新输入',
  companyEnCheck: '请输入正确的英文公司名',
  register_valid_QQmail: '当前不支持qq邮箱，请更换其他邮箱',
  register_valid_QQmail2: '不支持QQ邮箱，请您更换其他工作邮箱',
  register_Industry_s: '请选择行业类型',
  register_mail_succeeded: '邮箱验证成功!',
  register_mail_succeeded2: '验证码错误，请重新输入',
  register_mail_fa: '邮箱发送成功!',
  register_jk: '调用验证邮箱接口!',
  register_byz: '密码不一致，请确保您的密码一致',
  register_m_k: '请输入您的手机号',
  register_m_c: '请输入11位有效手机号',
  register_m_z: '请输入11位有效手机号',
  register_yz1: '密码不一致，请确保您的密码一致',
  register_yz2: '请输入公司名称全名',
  register_yz3: '请输入11位有效手机号',
  register_yz4: '请输入4位数字验证码!',
  register_yz5: '请输入公司名称全名',
  register_f1: '贸易商',
  register_f2: '物流供应商',
  register_f3: '物流产品服务商',
  register_hy: '欢迎访问JCtrans管理系统平台！',
  register_xs:
    '系统检测到您的密码较弱或您刚刚重置过密码，为了您的密码安全，请立即修改密码。',
  register_J: '请输入您的当前密码',
  register_CN: '确认新密码',
  register_xj: '密码不一致，请确保您的密码一致',
  register_xgsb: '修改失败!',
  register_noyy: '密码不一致，请确保您的密码一致',
  register_c_s1: '注册提交成功',
  register_c_s2: '欢迎加入JCtrans，注册结果已发送至您的邮箱。',
  register_c_s3:
    '如果您的注册信息不真实或发布任何不当信息，JCtrans有权删除您的账号。',
  register_c_Back: '返回登录页',
  register_qyz: '请验证您的电子邮箱,以免影响部分功能使用',
  register_bu1: '您的中文名称',
  register_bu2: '您的英文名称',
  register_bu3: '公司中文名',
  register_bu4: '请输入您的公司中文名称',
  register_bu5: '请输入您的公司英文名称',
  register_bu6: '公司中文名',
  register_bu7: '公司英文名',
  register_bu8: '中文姓名',
  register_bu9: '英文姓名',
  register_bu10: '您的中文名称',
  register_bu11: '您的名称',
  register_bu12: '密码不能为空，请重新输入',
  register_bu13: '公司英文名称',
  register_bu14: '英文名',
  register_bu15: '请输入公司名称',
  register_bu16: '请输入你的名称',
  register_sj1: '请输入11位手机号码',
  register_sj2: '请输入11位手机号码',
  register_sj3: '请输入您的手机号',
  register_cn1: '公司中文名称',
  register_cn2: '请输入您的公司名称',
  register_cny1: '公司英文名称',
  register_cny2: '请输入您的公司英文名称',
  register_yn1: '姓名',
  register_yn2: '请输入您的姓名',
  register_yny1: '英文名',
  register_yny2: '请输入您的英文名',
  register_mrny1: '请输入您的公司英文名称',
  register_mrcny1: '请输入您的英文名',
  register_changeM1: '新旧密码不能相同',
  register_changeM2: '新密码不能为空，请重新输入',
  register_changeM3: '旧密码不能为空，请重新输入',
  register_MsgCode1: '请输入4位数字短信验证码',
  register_MsgCode_mail: '请输入4位数字邮箱验证码',
  
  register_MsgCode2: '短信验证码错误，请重新输入',
  register_MsgCode3: '请输入少于 190 个字符.',
  register_MsgCode4: '请输入少于 255 个字符.',
  register_MsgCode5: '请输入少于 200 个字符.',
  register_MsgCode6: '请输入至少 2 个字符.',
  register_MsgCode_repeat: '已被占用，请重新输入',
  register_by_code_msg: '未注册验证后自动登录，注册即代表同意',
  register_agreement_prefix: '我已阅读并同意',
  register_agreement_name: '《用户条款和协议》',
  register_agreement_Policy: '《隐私政策》',
  register_agreement_Separator: '和',
  register_agreement_Separator_dot: '。',
  register_agreement_title: '用户条款和协议',
  register_police_title: '隐私政策',
  register_and_login: '立即揽货',
  register_agreement_content: `欢迎访问我们的网站。如果您继续浏览和使用本网站，则表示您同意遵守以下JCtrans条款，并受其约束。这些条款由杰西圈（北京）科技有限公司管辖。<br /><br />

以下的“您”指的是我们网站的用户或浏览者。浏览本网站或使用本网站的人士须遵守下列条款及条件。<br /><br />

本网站网页内容仅供您参考及使用。如有更改，恕不另行通知。我们保留随时修改本协议或其与网站或服务相关的政策的权利，并在本协议的更新版本发布于网站后生效。在任何此类更改后继续使用本网站即表示您对此类更改的认同。<br /><br />

我们或任何第三方均不对在网站上为任何特定目的找到或提供的信息和材料的准确性、及时性、性能、完整性或适宜性提供任何保证或保障。您承认这些信息和材料可能包含不准确或错误，我们明确在法律允许的最大范围内不承担任何此类不准确或错误的责任。偶尔在网站上可能会有包含印刷错误、不准确或遗漏的信息，这些信息可能与产品描述、可用性、促销和优惠有关。如果本网站或任何相关服务上的任何信息不准确(包括在您提交订单后)，我们保留随时更正任何错误、不准确或遗漏的权利，以及更改或更新信息或取消订单的权利，而且无需事先通知。除法律规定外，我们没有义务更新、修改或澄清本网站的信息，包括但不限于运费或货盘等其他信息。本网站不使用指定的更新或刷新日期来表明本网站或任何相关服务上的所有信息已被修改或更新。<br /><br />

您使用本网站上的任何信息或材料的风险完全由您自己承担，我们对此不承担责任。您有责任自主明确本网站提供的任何产品、服务或信息符合您的特定要求。如果您在本网站创建帐户，您有责任维护帐户的安全，并对帐户下发生的所有活动和与之相关的任何其他行为负全部责任。提供任何类型的虚假联系信息可能导致您的帐户被终止。您必须立即通知我们任何未经授权使用您的帐户或任何其他违反安全的行为。我们将不对贵方的任何作为或不作为负责，包括因该等作为或不作为而引起的任何类型的损害。如果我们确定您违反了本协议的任何条款，或者您的行为或内容可能损害我们的声誉和商誉，我们可以暂停、禁用或删除您的账户(或其任何部分)。如因上述原因，我们删除您的账户，您不得重新注册我们的服务。我们可能会屏蔽您的电子邮件地址和互联网协议地址，以防止您再次注册。<br /><br />

您同意本网站对以下信息包括搜集、整理、复制、使用、披露等：<br />
a.您身份及资质信息；<br />
b.您交易信息；<br />
c.您为商业沟通及宣传上传或提供的各类信息；<br /><br />

您应对所有提交内容的准确性、质量、完整性、合法性、可靠性、适度性和知识产权所有权或使用权承担全部责任。我们可能会监控您使用我们的服务提交或创建的网站内容。您授予我们为向您提供服务而访问、复制、分发、存储、传输、重新格式化、显示和执行您用户帐户内容的权限。在不限制任何上述陈述或保证的情况下，我们有权(但无义务)自行决定拒绝或删除我们合理认为违反我们任何政策或在任何方面有害或令人不适的任何内容。<br /><br />

如果您决定启用、访问或使用第三方服务,建议您访问和使用的其他服务则完全由等其他服务的条款和条件控制,我们不支持也不负责其他服务,包括但不限于它们的内容或它们处理数据(包括您的数据)的方式，或您与此类其他服务提供商之间的任何交互。您需要放弃任何对JCtrans关于此类其他服务的索赔权利。JCtrans不承担因您启用、访问或使用任何此类其他服务，或您对此类其他服务的隐私惯例、数据安全流程或其他政策的依赖而造成的任何损害或损失。您可能会被要求在相关网站注册或登录该等其他服务。通过启用任何其他服务，您明确地允许JCtrans在必要时公开您的数据，以促进此类其他服务的使用或启用。<br /><br />

您保证：<br />
a.您自本网站获得的全部数据信息均用于本用户协议约定之目的，如商业洽谈、询盘、交易等；<br />
b.您不会将自本网站获取的数据信息用于与本网站存在竞争关系的业务、项目或其他类似商业目的；<br />
c.您对其自本网站获取的数据信息的使用不会对本网站的商誉造成任何不利影响；<br />
d.您不会将自本网站获取的数据信息，在未获本网站或数据信息上传者书面允许的情况下作本协议目的之外的搜集、整理、复制、使用、披露、再发布、出售及转售或其他交易等；<br />
e.您以本协议约定的商业目的、以常规的互联网使用方式获取和使用本网站的数据信息，不会通过机器人、爬虫程序、自动设备等类似手段对本网站数据信息进行非常规的获取和整理；<br />
f.您遵守本网站信息的获取和使用规则、不会以破坏或绕过本网站数据安全保障系统或措施的方式对本网站数据信息进行获取或作其他处理。<br /><br />

您违反本款保证的，本网站有权自发现时起立即采取包括封禁您帐号在内的任何必要措施；给本网站造成商誉或经济损失的，您予以赔偿。<br /><br />

您同意使用我们的网站或服务的风险完全由您自己承担。您同意以“现状”和“可用”为基础使用此类服务。我们明确拒绝任何形式的保证，包括但不限于关于适销性、特定目的的适用性和非侵权的保证。我们不保证服务将满足您的要求，或服务将不间断、及时、安全或无错误;我们也不保证通过使用服务可能获得的结果，或通过服务获得的任何信息的准确性或可靠性，或本服务中的缺陷将得到纠正。您理解并同意您会负责任何损害你的计算机系统或数据丢失所导致的材料和/或数据的下载。对于通过服务购买或获得的任何商品或服务，或通过服务进行的任何交易，我们不作任何保证。您从我们或通过本服务获得的任何口头或书面建议或信息，均不构成本协议中未明确规定的任何保证。<br /><br />

“即时通信IM”是基于“腾讯云”接口为用户提供在线即时通信的一项应用。为保障渠道安全和功能合规使用，本服务将对个人信息进行处理，包括但不限于信息收集、存储、使用、加工、传输等”。 请在法律法规、政策规定范围内使用服务。由于通信内容违规所产生的后果由您承担全部责任。此服务已通过 SOC 系列审计报告（包括 SOC 1、SOC 2、SOC 3）、网络安全等级保护2.0（三级）、ISO系列认证（包括 ISO 9001、ISO 20000、ISO 27001、ISO 27017、ISO 27018、ISO 27701、ISO 29151）、CSA STAR、NIST CSF、BS10012 和 KISMS 等认证。我们承诺仅按照您的授权处理相关数据，并采取相应的安全措施。<br /><br />

网站包含我们拥有或授权给我们的材料。本材料包括但不限于设计、布局、外观、外观和图形。未经jctrans.com/jctrans.net明示、书面许可，禁止转载。<br /><br />

本网站转载的所有商标(如有的话)均在本网站予以承认，但该等商标并非该经营者的财产或授权给该经营者使用。<br /><br />

除本协议规定的其他条款外，您不得使用本网站或其内容:(a)用于任何非法目的;(b)招揽他人实施或参与任何非法行为;(c)违反任何国际、行政区、省、市的法规、规章、法律或地方法规;(d)侵犯我们或他人的知识产权;(e)基于性别、性取向、宗教、民族、种族、年龄、原国籍或残疾而骚扰、虐待、侮辱、伤害、诽谤、蔑视、恐吓或歧视;(f)提交虚假或误导性的信息;(g)上传或传输将或可能以任何方式使用的病毒或任何其他类型的恶意代码，从而影响本服务或任何相关网站、其他网站或互联网的功能或运行;(h)收集或追踪他人的个人信息;(i)垃圾邮件、网络钓鱼、诱饵欺诈、假托、圈套或恶意下载数据;(j)为任何淫亵或不道德的目的;或干扰或规避本服务或任何相关网站、其他网站或互联网的安全特性。如果您违反任何被禁止的用途，我们保留终止使用本服务或任何相关网站的权利。未经授权使用本网站可能会引致索偿及/或触犯刑事罪行。<br /><br />

虽然本网站可能链接到其他网站，但我们并不直接或间接地暗示与任何链接网站的任何批准、协会、赞助或隶属关系，除非在此特别说明。我们不负责审查或评估任何企业或个人的产品或其网站的内容，我们也不保证。我们不对任何其他第三方的行为、产品、服务和内容承担任何责任或责任。您应仔细审阅通过本网站链接访问的任何网站的法律声明和其他使用条件。您链接到任何其他网站的风险由您自己承担。<br /><br />

未经jctrans.com/jctrans.net明确的事先书面同意，您不得从其他网站或文件创建到本网站的链接。<br /><br />

我们定期对网站和内容进行备份，并将尽最大努力确保这些备份的完整性和准确性。在发生硬件故障或数据丢失的情况下，我们将自动恢复备份，以尽量减少影响和停机时间。<br /><br />

您承认您已阅读本协议并同意其所有条款和条件。使用本网站或其服务即表示您同意接受本协议的约束。如果您不同意遵守本协议的条款，您将无权使用或访问本网站及其服务。<br /><br />

如果您对条款和条件有任何疑问，请联系我们。`,
  register_agreement_content_old: `欢迎访问我们的网站。如果您继续浏览和使用本网站，则表示您同意遵守以下JCtrans条款，并受其约束。这些条款由杰西圈（北京）科技有限公司管辖。<br /><br />
  以下的“您”指的是我们网站的用户或浏览者。浏览本网站或使用本网站的人士须遵守下列条款及条件。<br /><br />
  本网站网页内容仅供您参考及使用。如有更改，恕不另行通知。我们保留随时修改本协议或其与网站或服务相关的政策的权利，并在本协议的更新版本发布于网站后生效。在任何此类更改后继续使用本网站即表示您对此类更改的认同。<br /><br />
  我们或任何第三方均不对在网站上为任何特定目的找到或提供的信息和材料的准确性、及时性、性能、完整性或适宜性提供任何保证或保障。您承认这些信息和材料可能包含不准确或错误，我们明确在法律允许的最大范围内不承担任何此类不准确或错误的责任。偶尔在网站上可能会有包含印刷错误、不准确或遗漏的信息，这些信息可能与产品描述、可用性、促销和优惠有关。如果本网站或任何相关服务上的任何信息不准确(包括在您提交订单后)，我们保留随时更正任何错误、不准确或遗漏的权利，以及更改或更新信息或取消订单的权利，而且无需事先通知。除法律规定外，我们没有义务更新、修改或澄清本网站的信息，包括但不限于运费或货盘等其他信息。本网站不使用指定的更新或刷新日期来表明本网站或任何相关服务上的所有信息已被修改或更新。<br /><br />
  您使用本网站上的任何信息或材料的风险完全由您自己承担，我们对此不承担责任。您有责任自主明确本网站提供的任何产品、服务或信息符合您的特定要求。如果您在本网站创建帐户，您有责任维护帐户的安全，并对帐户下发生的所有活动和与之相关的任何其他行为负全部责任。提供任何类型的虚假联系信息可能导致您的帐户被终止。您必须立即通知我们任何未经授权使用您的帐户或任何其他违反安全的行为。我们将不对贵方的任何作为或不作为负责，包括因该等作为或不作为而引起的任何类型的损害。如果我们确定您违反了本协议的任何条款，或者您的行为或内容可能损害我们的声誉和商誉，我们可以暂停、禁用或删除您的账户(或其任何部分)。如因上述原因，我们删除您的账户，您不得重新注册我们的服务。我们可能会屏蔽您的电子邮件地址和互联网协议地址，以防止您再次注册。<br /><br />
  您应对所有提交内容的准确性、质量、完整性、合法性、可靠性、适度性和知识产权所有权或使用权承担全部责任。我们可能会监控您使用我们的服务提交或创建的网站内容。您授予我们为向您提供服务而访问、复制、分发、存储、传输、重新格式化、显示和执行您用户帐户内容的权限。在不限制任何上述陈述或保证的情况下，我们有权(但无义务)自行决定拒绝或删除我们合理认为违反我们任何政策或在任何方面有害或令人不适的任何内容。<br /><br />
  如果您决定启用、访问或使用第三方服务,建议您访问和使用的其他服务则完全由等其他服务的条款和条件控制,我们不支持也不负责其他服务,包括但不限于它们的内容或它们处理数据(包括您的数据)的方式，或您与此类其他服务提供商之间的任何交互。您需要放弃任何对JCtrans关于此类其他服务的索赔权利。JCtrans不承担因您启用、访问或使用任何此类其他服务，或您对此类其他服务的隐私惯例、数据安全流程或其他政策的依赖而造成的任何损害或损失。您可能会被要求在相关网站注册或登录该等其他服务。通过启用任何其他服务，您明确地允许JCtrans在必要时公开您的数据，以促进此类其他服务的使用或启用。<br /><br />
  您同意使用我们的网站或服务的风险完全由您自己承担。您同意以“现状”和“可用”为基础使用此类服务。我们明确拒绝任何形式的保证，包括但不限于关于适销性、特定目的的适用性和非侵权的保证。我们不保证服务将满足您的要求，或服务将不间断、及时、安全或无错误;我们也不保证通过使用服务可能获得的结果，或通过服务获得的任何信息的准确性或可靠性，或本服务中的缺陷将得到纠正。您理解并同意您会负责任何损害你的计算机系统或数据丢失所导致的材料和/或数据的下载。对于通过服务购买或获得的任何商品或服务，或通过服务进行的任何交易，我们不作任何保证。您从我们或通过本服务获得的任何口头或书面建议或信息，均不构成本协议中未明确规定的任何保证。<br /><br />
  “即时通信IM”是基于“腾讯云”接口为用户提供在线即时通信的一项应用。为保障渠道安全和功能合规使用，本服务将对个人信息进行处理，包括但不限于信息收集、存储、使用、加工、传输等”。 请在法律法规、政策规定范围内使用服务。由于通信内容违规所产生的后果由您承担全部责任。此服务已通过 SOC 系列审计报告（包括 SOC 1、SOC 2、SOC 3）、网络安全等级保护2.0（三级）、ISO系列认证（包括 ISO 9001、ISO 20000、ISO 27001、ISO 27017、ISO 27018、ISO 27701、ISO 29151）、CSA STAR、NIST CSF、BS10012 和 KISMS 等认证。我们承诺仅按照您的授权处理相关数据，并采取相应的安全措施。<br /><br />
  网站包含我们拥有或授权给我们的材料。本材料包括但不限于设计、布局、外观、外观和图形。未经jctrans.com/jctrans.net明示、书面许可，禁止转载。<br /><br />
  本网站转载的所有商标(如有的话)均在本网站予以承认，但该等商标并非该经营者的财产或授权给该经营者使用。<br /><br />
  除本协议规定的其他条款外，您不得使用本网站或其内容:(a)用于任何非法目的;(b)招揽他人实施或参与任何非法行为;(c)违反任何国际、行政区、省、市的法规、规章、法律或地方法规;(d)侵犯我们或他人的知识产权;(e)基于性别、性取向、宗教、民族、种族、年龄、原国籍或残疾而骚扰、虐待、侮辱、伤害、诽谤、蔑视、恐吓或歧视;(f)提交虚假或误导性的信息;(g)上传或传输将或可能以任何方式使用的病毒或任何其他类型的恶意代码，从而影响本服务或任何相关网站、其他网站或互联网的功能或运行;(h)收集或追踪他人的个人信息;(i)垃圾邮件、网络钓鱼、诱饵欺诈、假托、圈套或恶意下载数据;(j)为任何淫亵或不道德的目的;或干扰或规避本服务或任何相关网站、其他网站或互联网的安全特性。如果您违反任何被禁止的用途，我们保留终止使用本服务或任何相关网站的权利。未经授权使用本网站可能会引致索偿及/或触犯刑事罪行。<br /><br />
  虽然本网站可能链接到其他网站，但我们并不直接或间接地暗示与任何链接网站的任何批准、协会、赞助或隶属关系，除非在此特别说明。我们不负责审查或评估任何企业或个人的产品或其网站的内容，我们也不保证。我们不对任何其他第三方的行为、产品、服务和内容承担任何责任或责任。您应仔细审阅通过本网站链接访问的任何网站的法律声明和其他使用条件。您链接到任何其他网站的风险由您自己承担。<br /><br />
  未经jctrans.com/jctrans.net明确的事先书面同意，您不得从其他网站或文件创建到本网站的链接。<br /><br />
  我们定期对网站和内容进行备份，并将尽最大努力确保这些备份的完整性和准确性。在发生硬件故障或数据丢失的情况下，我们将自动恢复备份，以尽量减少影响和停机时间。<br /><br />
  您承认您已阅读本协议并同意其所有条款和条件。使用本网站或其服务即表示您同意接受本协议的约束。如果您不同意遵守本协议的条款，您将无权使用或访问本网站及其服务。<br /><br />
  如果您对条款和条件有任何疑问，请联系我们。`,
  register_police_content: `本隐私政策(“政策”)描述jctrans.com/jctrans.net(统称为“JCtrans”,
    “我们”或“我们的”)如何收集、保护和使用您(统称为“用户”，“您”或“您的”)可能在jctrans.com/jctrans.net网站及其任何产品或服务(统称为“网站”或“服务”)上提供的个人身份信息(统称为“个人信息”)。它还描述了我们在使用您的个人信息方面为您提供的选择，以及您如何访问和更新这些信息。本政策不适用于本公司不拥有或不控制的公司，同时不适用于本公司不雇用或不管理的个人。
    <br /><br /><span class="agreementDetail_title">收集个人信息</span
    ><br /><br />
    当您在本网站创建帐户、发布内容、填写任何在线表格时，我们接收并存储您有意向为我们提供的任何信息。如有需要，这些信息可能包括您的电子邮件地址、姓名、电话号码、地址或其他个人信息。您可以选择不向我们提供某些信息，但这样您可能无法使用本网站的某些功能。
    <br /><br /><span class="agreementDetail_title">收集非个人信息</span
    ><br /><br />
    当您访问本网站时，我们的服务器会自动记录您的浏览器发送的信息。这些数据可能包括但不限制于：您设备的IP地址、浏览器类型、版本、操作系统类型和语言首选项,或您来到我们的网站之前访问的网页、在我们网站访问的页面
    、在这些页面所花费的时间、在我们的网站上搜索的信息，访问时间和日期，以及其它统计数据。
    <br /><br /><span class="agreementDetail_title">管理个人信息</span
    ><br /><br />
    您可以访问、添加、更新和删除有关您的某些个人信息。您可以查看、更新和删除的信息可能会随着网站或服务的变化而变化。然而，当您更新信息时，我们可能会在记录中保留一份未修改信息的副本。在您的帐户处于活动状态或需要向您提供服务时我们将保留您的信息。您从帐户中删除这些信息后，某些信息可能会保留在我们的记录中。我们将在必要时保留并使用您的信息，以遵守我们的法律义务、解决争议并执行我们的协议。在您更新或删除个人信息后，我们可能使用源自或合并您个人信息的任何汇总数据，但不会用以识别您个人身份的方式去使用。
    <br /><br /><span class="agreementDetail_title">收集信息的使用</span
    ><br /><br />
    jctrans.com/jctrans.net作为负责数据处理的一方，将因以下目处理您的个人数据:<br />
    1.管理您作为平台用户的注册，以识别您并让您访问为已注册的平台用户提供的服务。<br />
    2.通过电子邮件通知您有关功能、产品、或服务的有必要的信息。<br />
    3.通过我们平台上的客户服务渠道回应您的任何请求或查询。<br />
    4.我们还使用您的信息生成汇总的非识别数据。<br />
    我们从您收集的任何信息可能会被用于您个性化的体验、改善我们的网站、改善客户服务以及运行和运营我们的网站和服务。收集的非个人信息仅用于识别潜在的滥用案例和建立有关网站使用的统计信息。
    <br /><br /><span class="agreementDetail_title">时事通讯</span
    ><br /><br />
    我们提供电子通讯，您可以随时自愿订阅。您可以选择停止接收我们的通讯或营销电子邮件，请按照这些电子邮件中包含的退订指示操作或联系我们。请注意，即使您退订成功，你还将继续收到必要的交易电子邮件。
    <br /><br /><span class="agreementDetail_title">Cookies</span
    ><br /><br />
    本网站使用“Cookies”来帮助您个性化在线体验。Cookies是一个文本文件，它被网页服务器放置在你的硬盘上。Cookies不能用于运行程序或向您的计算机传递病毒。您的Cookies是唯一的，并且只能被发布Cookies给你的域内的web服务器读取。我们可能会使用Cookies收集、存储和跟踪信息，以进行统计目的来运营我们的网站和服务。您有接受或拒绝Cookies的权利。大多数浏览器自动接受Cookies，但如果你愿意，你通常可以修改浏览器设置来拒绝Cookies。
    <br /><br /><span class="agreementDetail_title">信息安全</span
    ><br /><br />
    我们在受控、安全的环境中保护您在计算机服务器上提供的信息，防止未经授权的访问、使用或披露。我们保持合理的行政、技术和物理安全措施，以防止在其控制和保管下的个人信息受到未经授权的访问、使用、修改和披露。但是，通过互联网或无线网络传输的数据无法得到保证。因此，在我们努力保护您的个人信息的同时，您需要认可<br />
    1.互联网存在我们无法控制的安全和隐私限制;<br />
    2.不能保证您与本网站之间交换的任何及所有信息和数据的安全性、完整性和隐私性;<br />
    3.尽管我们已尽最大努力，第三方仍可能在运输过程中查看或篡改任何此类信息和数据
    。<br />
    如果发生个人信息安全事件，我们将启动应急响应计划，以防止此类安全事件的扩大，并以电子邮件、推送通知、公告等形式通知您。同时，我们会为您提供信息安全方面的建议。
    请妥善保管您的帐号和密码信息，以免个人信息泄露。jctrans.com/jctrans.net只对jctrans.com/jctrans.net平台或网站直接导致您的个人信息泄露的情况负责。
    <br /><br /><span class="agreementDetail_title">数据泄露</span
    ><br /><br />
    如果我们意识到,网站的安全性被破坏或用户的个人信息透露给无关的第三方的外部活动,包括但不限于安全攻击或欺诈,我们有权采取适当措施合理,包括,但不限于,调查和报告，通知执法部门并与执法部门合作。在发生数据泄露的情况下，如果我们认为用户有受到损害的风险，或者法律另有要求，我们将通过受影响的个人做出合理的措施。当我们这样做时，我们将在网站上发布通知，给您发送电子邮件。
    <br /><br /><span class="agreementDetail_title">法律披露</span
    ><br /><br />
    在法律需要或法律允许的情况下，如果我们需要遵守传票或类似的法律程序,或当我们相信诚信披露是保护我们的必要权利,或为了保护您的安全和他人的安全,调查欺诈,或回应政府请求，我们将披露任何我们收集，使用或接收到的信息。如果我们经历业务转型，例如被另一家公司合并或收购，或出售其全部或部分资产，您的用户帐户和个人数据可能会在转移的资产中。
    <br /><br /><span class="agreementDetail_title">变更和修改</span
    ><br /><br />
    我们保留随时修改与本网站或服务有关的本隐私政策的权利，并且会在本政策的更新版本发布于本网站时生效。在任何此类更改后继续使用本网站即说明您已经同意对此类的更改。
    <br /><br /><span class="agreementDetail_title">接受本保单</span
    ><br /><br />
    您确认已阅读本保单并同意其所有条款和条件。使用本网站或其服务即表示您同意受本政策的约束。如果您不同意遵守本政策的条款，您将无权使用或访问本网站及其服务。
    <br /><br /><span class="agreementDetail_title">联系我们</span
    ><br /><br />
    如果您对本政策有任何疑问，请与我们联系。`,
  // newRegister
  n_Register_Password: '密码',
  n_register_qyz: '验证码已发送至',
  n_register_qyz2: '邮箱成功验证后，可使用帮货代的发盘、应盘等功能',
  n_register_manual: '请尝试下述的步骤来排除故障:',
  n_register_manual2:
    '1. 请检查您的垃圾邮件和已删除邮件目录下是否有来自 info@jctrans.net 的邮件。有时电子邮件会被您的电子邮箱服务商错误的识别为垃圾邮件。',
  n_register_manual3:
    '2. 稍等片刻。有时接收电子邮件缓慢，需要花几分钟时间来接收电子邮件。',
  n_register_manual4: '3. 如果您依然无法找到我们的邮件，请联系平台客服人员。',
  n_register_contact_us: '联系我们',
  n_register_code: '请选择区号',
  n_register_phone: '请输入手机号',
  n_register_phone1: '手机号',
  n_register_new: '新用户注册',
  n_register_Wel: '欢迎来到JCtrans!',
  n_register_Join: '链全球商机 帮货代盈利',
  register_label_email: '邮箱',
  register_label_cell: '手机号码',
  register_valid_areaCode: '区号不能为空',
  register_repeat_companyName: '公司名称已存在，请联系客服',
  bindCompany_tip: '填写公司信息',
  bindCompany_confirm: '完成并进入',

  // 修改密码
  changePass_title: '修改密码',
  old_pwd_verify: '旧密码验证',
  email_verify: '邮箱验证',
  mobile_verify: '手机号验证',
  changePass_success: '修改成功',
  changePass_content: '您当前的密码较弱，请修改密码',
  register_UserName_FNP: '2-30个字符，包括字母或数字',
  register_UserName_FNP_null: '用户名不能为空，请重新输入',
  changePass_cpLabel: '当前密码',
  changePass_npLabel: '设置新密码',
  changePass_conpLabel: '确认新密码',
  changePass_npassPlaceholder: '请输入6-20位字符，包含字母、数字和符号',
  // 滑动验证
  verification_title: '请完成安全验证',
  verification_explain: '向右滑动完成验证',
  verification_failed: '验证失败',
  verification_success: '验证成功',
  // 邮件退订
  emailC_title: '确定退订邮件提醒吗, 如果退订您将收不到关于jctrans的提醒消息',
  emailC_email_message: '请输入电子邮箱',
  emailC_mail: '退订邮箱',
  emailC_type: '退订类型',
  emailC_type1: '关注地区每日询盘提醒邮件',
  emailC_type_message: '请选择退订类型',
  emailC_reason: '退订原因',
  emailC_reason1: '提醒邮件太多, 造成了困扰',
  emailC_reason2: '发送的时间对我造成了困扰',
  emailC_reason3: '主题不明确, 没理解具体内容',
  emailC_reason4: '邮件内容对我没有用处',
  emailC_reason5: '邮件格式错乱',
  emailC_reason6: '其他原因',
  emailC_Submit: '确定退订',
  emailC_reasons_message: '请选择退订原因',
  emailC_success: '邮件退订成功！',
  emailC_otherR_error: '请填写其他原因',

  // 企业信息-企业账号
  companyAccount_title: '企业账号管理',
  company_account_sort: '序号',
  company_account_account: '用户名',
  company_account_cn_name: '中文姓名',
  company_account_en_name: '英文姓名',
  company_account_en_name_En: '姓名',
  company_account_type: '状态',
  company_account_position: '身份',
  company_account_action: '操作',
  company_account_action_success: '操作成功',
  company_account_add_success: '添加成功',
  company_account_edit_success: '编辑成功',
  company_account_setMain_tips: '是否确认转让主账号权限？',
  company_account_setMain_content_prefix: '设置',
  company_account_setMain_content_suffix: '为公司主账号',
  company_Master_account: '主账号',
  company_Sub_account: '子账号',
  setup_phone: '手机号',
  company_setting_edit: '编辑',
  company_setting_del: '删除',
  company_setting_del_title: '是否确认删除？',
  company_setting_del_tips1: '子账号',
  company_setting_del_tips2: '删除后将无法恢复！',
  company_account_del_success: '删除成功',
  company_setting_resetPass_title: '是否确认重置该账号密码?',
  company_setting_resetPass_tips1: '重置后的密码将发送到邮箱',
  company_account_resetPass_success: '重置密码成功',
  company_setting_reason: '查看原因',
  company_setting_reason_title: '停用原因',
  company_setting_more: '更多',
  company_setting_Master: '设置为主账号',
  company_setting_resetPass: '重置密码',
  company_setting_customerService: '设置为客服',
  company_add_son: '新建子账号',
  company_edit_son: '编辑子账号',
  company_header_tips: '会员最多可创建9个子账号',
  company_header_tips2: '最多可创建4个子账号',
  company_header_tips3: 'JCE会员最多可创建15个子账号',
  setup_Send: '发送',
  sAccount_status_audit: '审核中',
  sAccount_status_disable: '停用',
  sAccount_status_normal: '正常',
  company_account_kf: '客服',

  // 企业账号-验证弹框
  verify_own_operation: '请验证您的身份，以确保是您本人操作',
  verify_Verification_Code: '验证码',
  verify_enter_code: '请输入四位验证码',
  verify_Mailbox_cannot: '邮箱无法接收邮件？',
  verify_Contact_service: '联系客服',
  verify_Submit_validation: '提交',
  setup_Resend: '重新发送',
  verify_send_success: '发送成功',
  verify_code_format_error: '验证码格式错误',
  placeholder_code: '请输入验证码',

  // 企业账号-子账号表单
  sonAccount_account_ph: '6-30个字符，包括字母或数字',
  sonAccount_nameCn_ph: '请输入您的中文姓名',
  sonAccount_nameEn_ph: '请输入您的英文姓名',
  sonAccount_mobile_ph: '请输入手机号码',
  sonAccount_email_ph: '例：Email@jctrans.net',
  sonAccount_passwd_ph: '6-20位字符，包含字母和数字',
  sonAccount_currentPass_ph: '6-20位字符，包含字母和数字',
  setup_cancel: '取消',
  company_account_sNumMax_tips:
    '您当前子账号数量已到达上限，请联系客服进行购买',
  company_account_sNumMax_tips_noVip:
    '非会员，最多可设置5个账号，开通会员可购买更多',
  company_validateComName_btn: '联系客服',
  sonAccount_account_r1: '用户名不能为空，请重新输入',
  sonAccount_account_r2: '用户名为6-30个字符，包括字母或数字',
  sonAccount_nameCn_r1: '请输入您的中文姓名',
  sonAccount_nameEn_r1: '请输入您的英文姓名',
  sonAccount_nameEn_r2: '英文名不能有中文',
  sonAccount_mobile_r1: '请输入您的手机号',
  sonAccount_mobile_r2: '请输入正确的手机号',
  sonAccount_email_r1: '请输入您的邮箱',
  sonAccount_email_r2: '请输入有效的邮箱地址',
  sonAccount_passwd_r1: '密码不能为空，请重新输入',
  sonAccount_passwd_r2: '密码为6-20位字符，包含字母和数字',
  sonAccount_currentPass_r1: '密码不能为空，请重新输入',
  sonAccount_currentPass_r2: '密码为6-20位字符，包含字母和数字',
  sonAccount_currentPass_r3: '密码不一致，请确保您的密码一致',
  personal_tips_addsubmit: '确认添加子账号？',
  personal_tips_editsubmit: '确认更新子账号信息？',
  areaCode_require: '请选择',

  // 企业账号表单label
  sonAccount_account_label: '用户名',
  sonAccount_nameCn_label: '中文姓名',
  sonAccount_nameEn_label: '英文姓名',
  sonAccount_mobile_label: '手机号',
  sonAccount_email_label: '邮箱',
  sonAccount_passwd_label: '设置密码',
  sonAccount_currentPass_label: '确认密码',

  // 独立注册链接
  Independent_registration_username: '请输入6-30位字母或者数字',
  Independent_registration_password: '请输入6-20位字符，包含字母、数字和符号',
  Independent_registration_confirmPassword: '请输入相同密码',
  Independent_registration_email: '请输入您的邮箱',
  Independent_registration_email2: '请输入正确的邮箱',
  Independent_registration_companyNameCh_p: '请输入您的公司中文名称',
  Independent_registration_companyNameCh: '请输入正确中文公司名称',
  Independent_registration_companyNameEn_p: '请填写您的公司英文名称',
  Independent_registration_companyNameEn: '请输入正确英文公司名称',
  Independent_registration_ChineseName_p: '请填写您的真实姓名',
  Independent_registration_ChineseName: '请输入正确中文姓名',
  Independent_registration_EnglishName_p: '请填写您的英文名字',
  Independent_registration_EnglishName: '请输入正确英文姓名',
  Independent_registration_CellPhone_p: '请输入您的11位手机号码',
  Independent_registration_CellPhone: '请输入正确11位数字',
  Independent_registration_verificationCode: '请输入正确验证码',
  Independent_registration_JobTitle: '请输入正确中文岗位名称',
  Independent_registration_CompanyLogo: '请上传公司Logo',
  Independent_registration_DataOfEstablishment: '请选择成立时间',

  Independent_registration_ConfirmInfo1: '请确认提交',
  Independent_registration_ConfirmInfo2: '',
  Independent_registration_ConfirmInfo_Yes: '是',
  Independent_registration_ConfirmInfo_No: '否',

  Independent_registration_min2: '最小需要2字符',

  // 上传公司 logo
  upload_form_logo_upload: '选择',
  upload_form_logo_submit: '提交',
  upload_form_logo_submit_success: '上传成功',
  upload_form_logo_submit_error:
    '文件格式错误，请上传图片类型,如：JPG，PNG后缀的文件。',
  upload_form_logo_submit_error2: '文件过大，请检查或者联系我们',
  // JCYS-1289
  invite_member: '邀请成员加入',
  invite_member_company: '邀请成员加入本公司',
  invite_copy_link: '复制邀请链接，注册直接加入当前公司：',
  invite_copy: '复制',
  invite_examine: '申请加入您的公司后，需要您进行审核确认',
  join_company: '加入公司申请',
  join_company_tips:
    '现有一账号申请加入您的公司，请确实是否同意加入，同意加入后该账号会成为您公司下的子账号：',
  join_agree: '同意加入',
  join_refuse: '拒绝',
  join_user_name: '用户姓名',
  join_email: '邮箱',
  join_mobile: '手机号码',
  examine: '审核',
  join_company_again_sure:
    '请确认是否同意该账号加入您的公司，加入后可以使用查看公司下所有信息',
  join_company_again_cancel: '请确认是否拒绝该账号加入您的公司？',

  register_already_tip: '该公司已存在。您可申请加入。',
  register_join_in: '点击申请加入 >>',
  register_already_join: '公司名称',
  register_already_company: '公司所在城市',
  register_name_en: '您的英文姓名',
  register_name_cn: '您的中文姓名：',
  register_name_placeholder: '请输入您的姓名，以证明您的身份',
  register_name_tips1: '请输入您的中文姓名',
  register_name_tips2: '仅能输入中英文字符及符号，最多50个字',
  register_name_tips3: '请输入您的英文姓名',
  register_name_tips4: '仅能输入英文字符及符号，最多50个字',
  register_modify: '修改',
  register_first_name_p: '请输入您的名',
  register_last_name_p: '请输入您的姓',

  copy_success: '复制成功',
  copy_error: '复制失败',

  thirdParty: {
    back_to_form: '手机号/邮箱验证码登录',
    bind_title: '您已拥有账号，请选择账号绑定',
    bind_cancel: '取消',
    bind_confirm: '选择',
    sign_up: '注册并绑定',
    login_and_bind: '登录并绑定',
    sign_up_and_login: '注册并登录',
    click_to_bind: '去绑定',
    email_has_been_registered: '邮箱已注册',
    mobile_has_been_registered: '手机号已注册',
    bind_login_title: '您已有账号，登录可完成绑定',

    sign_in_with: '其他登录方式',
    wechat: '微信',
    facebook: 'Facebook',
    google: 'Google',
    linkedin: 'LinkedIn',

    back: '返回',

    password: '密码',
    verify_password: '验证密码',
    email: '邮箱',
    mobile: '手机号',
    verify_code: '验证码',

    account: '账号',

    user_has_other_bind: '账号已被绑定，请更换其他账号',
  },
}
export const m_en = {
  bindCompany: {
    tip: 'Please fill in your information, you can unlock services on JCtrans such as providing inquiries,quotes,and attending conference',
    selectCity: 'Select city of company',
    selectCityPH: 'Please enter the city',
    compNameCn: 'Company name（in Chinese）',
    compNameCnPH: 'Please enter the company name in Chinese',
    compNameEn: 'Company name（in English）',
    compNameEnPH: 'Please enter the company name in English',
    industry: 'Industry Sector',
    phone: 'cell phone',
    phonePH: 'Please enter the cell phone',
    verifyCode: 'Verification code',
    verifyCodeCellPH: 'Cell Verification code',
    verifyCodeEmailPH: 'Email Verification code',
    email: 'Email',
    obtain: 'Obtain',
    confirm: 'Confirm',
    ignore: 'Ignore',
    select_city: 'Please enter the city',
    compNameCn_p: 'Please enter company name in Chinese',
    compNameEn_p: 'Please enter company name',
    invalid_characters: 'Invalid characters',
    choose_category: 'Please select enterprise nature',
    emailRules: 'Invalid email address',
    verify_email_address_msg_correct_qq:
      'QQ mailbox is not avaliable, please change to another mailbox',
    area_code: 'select',
    mobileRules: 'Invalid mobile address',
    verify_phone_code: 'Please enter the phone verification code',
    verify_email_code: 'Please enter the email verification code',
    company_exists:
      'The company name already exists in the current national city',
    add_success: 'Success',
  },
  signIn_or_signUp: 'Sign In / Sign Up',
  signIn: 'Sign In',
  signInwait: 'Logging in....',
  form_Cancel: 'Cancel',
  form_Confirm: 'Confirm',
  form_Close: 'Close',
  form_Email: 'Email',
  form_Create: 'Submit',
  form_Create_z: 'Submiting...',
  name: 'Name',
  form_yes: 'YES',
  signIn_overTime:
    'The account has been logged in elsewhere.Do you want to log in again?',
  // login
  // footerText: 'Copyright © 2020-2022 JCtrans All Rights Reserved.',
  footerText_1: '© ',
  footerText_2: ' jctrans.com All rights reserved. ',
  login_kh: 'New to JCtrans?',
  login_kh2: 'Register now',
  login_introduce1: 'Already having a stable partnership? ',
  login_introduce2:
    "But it's never enough to have just one more professional agent.",
  login_introduce3: '',
  login_title: 'Connecting Global Opportunities',
  login_title2: 'Empowering Freight Forwarders',
  login_small_title:
    'Unlimited freight resources and inquiries from over 200 countries! ',
  // login_small_title2: 'Unlimited freight resources and inquiries from over 200 countries! ',
  login_SIGN: 'Sign Up',
  login_zh: 'Username',
  login_zh_new: 'Username/Email/Phone Number',
  login_mm: 'Password',
  login_CodeCn_no: 'Mobile phone verification code',
  login_Code: 'Verification code',
  login_Code_placeholder: 'Enter the result of the picture',
  login_Code2: 'Verification',
  login_Code_sp: 'Please enter 4 digits verification code',
  login_Forget: 'Forgot your password?',
  login_Remember: 'Remember Me',
  login_zh_p: 'Please enter your Username/phone number/email',
  login_mm_p: 'Please enter the password',
  login_Code_p: 'Please enter Verification',
  login_Code_m: 'Enter 4 Verification Code',
  login_LoggedIn:
    'The current account is logged in. Do you still want to log in again?',
  login_Tips: 'Tips',
  login_customerService_Tips: 'IM Customer Service',
  login_customerService_detail:
    'Please select the site you want to set the account as IM customer service.',
  login_fail2: '二次登陆失败', // 弃用
  login_label_user: 'Please enter your Username/phone number/email',
  login_label_password: 'Please enter the password',
  login_register: "Don't have an account?",
  login_passwd: 'Password Login',
  login_verify_code: 'Verification Code Login',
  login_getCode_again: 'Please click to get the verification code',
  login_title_new: 'Welcome Back to JCtrans',
  // 扫码登录
  login_code_expired: 'The QR code has expired',
  login_wx_tip: 'WeChat QR Code Login',
  login_wx_success: 'Scan successful',
  login_wx_again: 'Rescan QR code',
  login_wx_scan: 'Scan to login/register',
  login_account_passport: 'Password',
  login_account_passport_tip: 'Password/Verification Login',
  login_choose_title:
    'Please select whether you already have a JCtrans account',
  login_choose_tips:
    'If you already have a JCtrans account, you can directly link it with WeChat. If you do not have a JCtrans account, please register first',
  login_to_register: 'No account, register now',
  login_to_login: 'Already have a JCtrans account',
  login_bind_title: 'Log in and link with WeChat',
  login_bind_tips:
    'After linking, you can log in via WeChat scan, which is convenient and quick',
  login_bind_submit: 'Login and Link',
  login_account_paaport: 'Password Login',
  login_account: 'Username',

  forgetpass_zy1: 'Reset Password',
  forgetpass_zy2: 'Please enter the Username to reset the password',
  forgetpass_kf: 'Customer Service',
  forgetpass_yhm: 'User',
  forgetpass_yhm_p: 'Please enter your Username/phone number/email',
  forgetpass_Email: 'Email',
  forgetpass_Email_p: 'Please enter Email',
  forgetpass_hq1: 'Send Code',
  forgetpass_hq2: 'Resend(',
  forgetpass_hq3: ')',
  forgetpass_hq4: 'Send verification code',
  forgetpass_hq5: 'Verify Now',
  forgetpass_wj1: 'The username cannot be empty. Please enter it',
  forgetpass_wj2: '6-30 characters include letters or numbers',
  forgetpass_wj3: '6-30 characters include letters or numbers',
  forgetpass_wj4: 'Username must be include letters or numbers',
  forgetpass_wj5: 'The username is not exist',
  forgetpass_wj6: 'The password cannot be empty. Please enter it',
  forgetpass_wj7: 'The password must be at 6-20 characters only',
  forgetpass_wj8: 'The password must be at 6-20 characters only',
  forgetpass_wj9: '6-20 characters include letters, numbers and symbols',
  forgetpass_wj10: 'Email address is required',
  forgetpass_wj11: 'please enter the full company name',
  forgetpass_wj12: 'Do not include Chinese characters in company name',
  forgetpass_wj13: 'please enter the full company name',
  forgetpass_wj14: 'Wrong format for company name',
  forgetpass_wj15: 'please enter the full company name',
  forgetpass_wj16: 'Please enter your full name',
  forgetpass_wj17: 'Do not include Chinese characters in name',
  forgetpass_wj18: 'Wrong format for name',
  forgetpass_wj19: 'Please enter your full name',
  zc_cf: 'Resend the email',
  forgetpass_NewPassword: 'New Password',
  forgetpass_New_p: 'Please enter New Password',
  forgetpass_Confirm: 'Confirm Password',
  forgetpass_Confirm_p: 'Please enter Confirm Password',
  forgetpass_Phone: 'Cell Phone',
  forgetpass_Phone_p: 'Please enter your cell phone',
  forgetpass_PhoneCode: 'Verification code',
  forgetpass_PhoneCode_p: 'Please enter 4 digits verification code.',
  forgetpass_service: 'Customer Service',
  forgetpass_service1: 'Problem retrieving password ? Contact ',
  forgetpass_service2: '',
  forgetpass_service_lx: 'Customer Service',
  forgetpass_Contact: 'Customer ',
  forgetpass_Customer: 'Customer Service',
  forgetpass_Customer1:
    'The current account does not have a phone number and email, and cannot be verified. Please contact customer service directly',
  login_Back: 'Previous',
  login_Next: 'Next',
  login_zqCode: 'Incorrect verification code, please enter again',
  login_zk: 'Open ∨',
  login_sq: 'Back ∧',
  login_mm_atypism: 'Password mismatch, please make sure your passwords match',
  login_mmok: 'Password reset succeeded',
  forgetpass_5f:
    'A verification code will be sent to your email and it will be expired after 5 minutes. Please do not share your verification code with anyone.',
  forgetpass_5fs:
    'A verification code will be sent to your phone and it will be expired after 5 minutes. Please do not share your verification code with anyone.',
  Password_6_20: '6-20 characters include letters, numbers and symbols',
  Password_word: '6-20 characters include letters, numbers and symbols',
  Password_number: '6-20 characters include letters, numbers and symbols',
  // register
  register_Username_p: '6-30 characters include letters or numbers',
  register_step1: 'Create Account',
  register_step2: 'Settings',
  register_step3: 'Registration Complete',
  register_Title: 'New User Registration',
  register_UserName: 'Username',
  register_Password: 'Password',
  register_Confirm: 'Confirm Password',
  register_Name: 'Your Full Name',
  register_Email: 'Email',
  register_Company: 'Company Name in English',
  register_checkCompanyName_alert_title: 'Remid',
  register_checkCompanyName_alert:
    'The company has already existed. Contact customer service.',
  register_Country: 'Country/Region',
  register_Location: 'Location (City)',
  register_City: 'City',
  register_MobileCode: 'Verification code',
  register_IndustrySector: 'Industry Sector',
  register_RegistrationInformation: '注册信息',
  register_Way: 'Registration method',
  register_Explain:
    'You can directly use your email or phone number as your login account to log in to the system',
  register_Set_Password: '设置登录密码',
  register_I_Green: 'I agree',

  register_UserName_p: '6-30 characters include letters or numbers',
  register_UserName_FNP: '2-30 characters include letters or numbers',
  register_Password_p: '6-20 characters include letters, numbers and symbols',
  register_Confirm_p: '6-20 characters include letters, numbers and symbols',
  register_Name_p: 'Eg. David Beckham',
  register_Email_p: 'Email',
  register_Email_p2: 'Please enter your email address',
  register_Email_p3: 'Please enter company email for account safe',
  register_Email_p4:
    'Business Email Address, QQ Mail is not available',
  register_Email_p5: 'Please enter a valid business email address',
  register_Email_desc: 'Business email address build trust and reliability',
  register_Address_p1: "Search and select your company's country/region",
  register_Address_p2: "Search and select your company's city",
  register_Company_p: 'Please enter Company Name',
  register_Country_p: 'Please select a Country/Region',
  register_Country_sp: 'Location',
  register_Country_sp2: 'Location (City)',
  register_City_p: 'City',
  register_City_sp: 'Please select a city',
  register_see1: "We've sent an email to",
  register_see2: ' to verify your email address and activate your account.',
  register_verification: 'Wait to be verified...',
  register_InitiateValidation: 'Submit validation',
  register_again: 'Verification code error, please enter again',
  register_no_mail: "Can't find the email?",
  register_skip: 'Skip',
  register_fault:
    "Still can't receive the email? Please try the following steps:",
  register_fault1:
    '1. Please check your spam folder as it is very common to have email delivery problems because of automated filters.',
  register_fault2:
    '2. Please take a rest. It may take a few minutes to receive the email.',
  register_fault3:
    "3. If you're having trouble with receiving the email, please contact us.",
  register_valid_mail: 'Please enter a valid email address',
  companyEnCheck: 'please enter the correct company name',
  kq_isSearch: 'Searching',
  kq_placeholder: 'Company Name in Chinese',
  kq_onceSearch: 'Please enter the company name',
  kq_null: 'No matching company, please re-enter',
  register_valid_QQmail:
    'QQ mailbox is not avaliable, please change to another mailbox.',
  register_valid_QQmail2:
    'QQ email is not supported, please change other work email',
  register_Industry_s: 'Please select a Industry Sector',
  register_mail_succeeded: 'Email verification succeeded',
  register_mail_succeeded2: 'Incorrect verification code, please enter again',
  register_mail_fa: 'The email send succeed!',
  register_jk: '调用验证邮箱接口!', // 日志输出  弃用
  register_byz: 'Password mismatch, please make sure your passwords match',
  register_m_k: 'Please enter your cell phone',
  register_m_c: 'Please enter 11 digits phone number',
  register_m_z: 'Please enter 11 digits phone number',
  register_yz1: 'Password mismatch, please make sure your passwords match',
  register_yz2: 'Please enter the full company name',
  register_yz3: 'Please enter 11 digits phone number',
  register_yz4: 'Please enter 4 digits verification code',
  register_yz5: 'Please enter the full company name',
  register_f1: 'Logistics',
  register_f2: 'Trade',
  register_f3: 'Logistics Product Provider',
  register_noyy: 'Password mismatch, please make sure your passwords match',
  register_hy: 'Welcome to JCtrans management system platform !',
  register_xs:
    'Your password strength is weak. To protect your account security, please reset your password.',
  register_J: 'Please enter your current password',
  register_CN: 'Confirm new password',
  register_xj: 'Password mismatch, please make sure your passwords match',
  register_xgsb: 'Edit failed!',
  register_c_s1: 'Registration completed successfully',
  register_c_s2:
    'Thank you for registration. Please check registration result in your email.',
  register_c_s3:
    'JCtrans reserved the right to delete your account if you post any harmful or inveracious information.',
  register_c_Back: 'Back to Sign In',
  register_qyz:
    'To continue using the inquiry system, please verify your email address.',
  register_bu1: 'Your Full Name in Chinese',
  register_bu2: 'Eg. David Beckham',
  register_bu3: 'Company Name in Chinese',
  register_bu4: 'Company Name in Chinese',
  register_bu5: 'Company Name',
  register_bu6: 'Company Name in Chinese',
  register_bu7: 'Company Name in English',
  register_bu8: 'Chinese Name',
  register_bu9: 'Eg. David Beckham',
  register_bu10: 'Your Full Name in Chinese',
  register_bu11: 'Your Full Name in English',
  register_bu12: 'The password cannot be empty. Please enter it',
  register_bu13: 'Company Name in English',
  register_bu14: 'English Name',
  register_bu15: 'Please enter the full company name',
  register_bu16: 'Please enter your full name',
  register_sj1: 'Please enter 11 digits phone number.',
  register_sj2: 'Cell Phone',
  register_sj3: 'Please enter your mobile number',
  register_cn1: 'Company Name in Chinese',
  register_cn2: 'Company Name in Chinese',
  register_cny1: 'Company Name (in English)',
  register_cny2: 'Company Name in English',
  register_yn1: 'Chinese Name',
  register_yn2: 'Your Full Name in Chinese',
  register_yny1: 'English Name',
  register_yny2: 'Your Full Name in English',
  register_mrny1: 'Company Name in English',
  register_mrcny1: 'English Name',
  register_changeM1: 'Old and new passwords cannot be the same',
  register_changeM2: 'The new password cannot be empty. Please enter it',
  register_changeM3: 'The old password cannot be empty. Please enter it',
  register_MsgCode1: 'Please enter 4 digits message veriication code.',
  register_MsgCode_mail: 'Please enter 4 digits email verification code.',
  register_MsgCode2: 'Incorrect message verification code, please enter again.',
  register_MsgCode3: 'please enter less than 190 characters.',
  register_MsgCode4: 'please enter less than 255 characters.',
  register_MsgCode5: 'please enter less than 200 characters.',
  register_MsgCode6: 'please enter at least 2 characters.',
  register_MsgCode_repeat: "It's already occupied, please re- enter.",
  register_agreement_prefix: 'I agree',
  register_by_code_msg:
    'Automatically log in after verification if not registered. Registration means you agree',
  register_agreement_name: ' User Agreement ',
  register_agreement_Policy: ' Privacy Policy',
  register_agreement_Separator: 'and',
  register_agreement_Separator_dot: '.',
  register_agreement_title: 'User Agreement',
  register_police_title: 'Privacy policy',
  register_and_login: 'Join Us',
  register_agreement_content: `Welcome to our website. If you continue to browse and use the website, you are agreeing to comply with and be bounded by the following JCtrans terms and conditions, which are governed by Beijing JCtrans Network Co., Ltd.<br /><br />

The term "you" refer to the user or viewer of our website. The viewer or user of this website is subject to the following terms and conditions.<br /><br />

The content of the pages of the website is for your general information and use only. It is subject to change without notice. We reserve the right to modify this Agreement or its policies relating to the Website or Services at any time, effective upon posting of an updated version of this Agreement on the Website. Continued use of the Website after any such changes shall constitute your consent to such changes.<br /><br />

Neither we nor any third parties provide any warranty or guarantee as to the accuracy, timelines, performance, completeness, or suitability of the information and materials found or offered on the websites for any particular purpose. You acknowledge that such information and materials may contain inaccuracies or errors and we expressly exclude liability for any such inaccuracies or errors to the fullest extent permitted by law. Occasionally there may be information on the Website that contains typographical errors, inaccuracies, or omissions that may relate to product descriptions, availability, promotions, and offers.<br /><br />

We reserve the right to correct any errors, inaccuracies, or omissions, and to change or update information or cancel orders if any information on the Website or on any related services is inaccurate at any time without prior notice (including after you have submitted your order). We undertake no obligation to update, amend or clarify information on the Website including, but not limited to, freight rate information, except as required by law. No specified update or refresh date applied on the Website should be taken to indicate that all information on the Website or on any related services has been modified or updated.<br /><br />

Your use of any information or materials on the websites is entirely at your own risk, for which we shall not be liable. It shall be your own responsibility to ensure that any products, services, or information available through the websites meet your specific requirements. If you create an account on the Website, you are responsible for maintaining the security of your account and you are fully responsible for all activities that occur under the account and any other actions taken in connection with it. Providing false contact information of any kind may result in the termination of your account. You must immediately notify us of any unauthorized uses of your account or any other breaches of security. We will not be liable for any acts or omissions by you, including any damages of any kind incurred as a result of such acts or omissions. We may suspend, disable, or delete your account (or any part thereof) if we determine that you have violated any provision of this Agreement or that your conduct or content would tend to damage our reputation and goodwill. If we delete your account for the foregoing reasons, you may not re-register for our services. We may block your email address and internet protocol address to prevent further registration.<br /><br />

You agree that this website may collect, compile, reproduce, use, and disclose the following information:<br />
a. Your identity and qualification information;<br />
b. Your transaction information;<br />
c. Any information you upload or provide for business communication and promotion purposes.<br /><br />


You shall have sole responsibility for the accuracy, quality, integrity, legality, reliability, appropriateness, and intellectual property ownership or right to use of all submitted contents. We may monitor contents on the Website submitted or created using our Services by you. You grant us permission to access, copy, distribute, store, transmit, reformat, display, and perform the contents of your user account as required for the purpose of providing the Services to you. Without limiting any of those representations or warranties, we have the right, though not the obligation, to, in our own sole discretion, refuse or remove any content that, in our reasonable opinion, violates any of our policies or is in any way harmful or objectionable.<br /><br />

If you decide to enable, access, or use third-party services, be advised that your access and use of such other services are governed solely by the terms and conditions of such other services, and we do not endorse, are not responsible or liable for, and make no representations as to any aspect of such other services, including, without limitation, their content or the manner in which they handle data (including your data) or any interaction between you and the provider of such other services. You irrevocably waive any claim against JCtrans with respect to such other services. JCtrans is not liable for any damage or loss caused or alleged to be caused by or in connection with your enablement, access, or use of any such other services, or your reliance on the privacy practices, data security processes, or other policies of such other services. You may be required to register for or log into such other services on their respective websites. By enabling any other services, you are expressly permitting JCtrans to disclose your data as necessary to facilitate the use or enablement of such other services.<br /><br />

You represent and warrant that:<br />
a. All data and information you obtain from this website shall be used solely for the purposes set forth in this User Agreement, including business negotiations, inquiries, and transactions;<br />
b. You will not use any data or information obtained from this website for any business, project, or other similar commercial purpose that competes with this website;<br />
c. Your use of any data or information obtained from this website will not adversely affect the goodwill of this website;<br />
d. You will not collect, compile, reproduce, use, disclose, republish, sell, resell, or otherwise trade any data or information obtained from this website for purposes beyond those stipulated in this Agreement without the prior written consent of this website or the uploader of such information;<br />
e. You will obtain and use the website’s data and information only for the commercial purposes set forth in this Agreement and in the ordinary course of Internet use, and you will not acquire or compile the website’s data and information through unconventional means such as robots, crawlers, automated devices, or similar technologies;<br />
f. You will comply with the rules for obtaining and using information from this website, and will not obtain or process data and information from this website in a manner that damages or bypasses the website’s data security protection systems or measures.<br /><br />

If you violate the warranties in this section, this website has the right to immediately take any necessary measures from the time of discovery, including blocking your account. If such violation causes reputational or economic loss to this website, you shall compensate accordingly.<br /><br />

You agree that your use of our Website or Services is solely at your own risk. You agree that such Services is provided on an "as is" and "as available" basis. We expressly disclaim all warranties of any kind, whether express or implied, including but not limited to the implied warranties of merchantability, fitness for a particular purpose, and non-infringement. We make no warranty that the Services will meet your requirements, or that the Services will be uninterrupted, timely, secure, or error-free; nor do we make any warranty as to the results that may be obtained from the use of the Services or as to the accuracy or reliability of any information obtained through the Services or that defects in the Service will be corrected. You understand and agree that any material and/or data downloaded or otherwise obtained through the use of Services is done at your own discretion and risk and that you will be solely responsible for any damage to your computer system or loss of data that results from the download of such material and/or data. We make no warranty regarding any goods or services purchased or obtained through the Services or any transactions entered into through the Service. No advice or information, whether oral or written, obtained by you from us or through the Services shall create any warranty not expressly made herein.<br /><br />

"Instant Messaging IM" is an application that provides users with online instant messaging based on the interface of "Tencent Cloud". For channel security and functional compliance, we will process personal information, including but not limited to information collection, storage, use, processing, transmission, etc. Please use the service under laws, regulations and policies. You take full responsibility for consequence arising from the illegal communications. This service has passed SOC series audit reports (SOC 1, SOC 2, SOC 3), cyber security protection 2.0 (level 3), ISO series certification (ISO 9001, ISO 20000, ISO 27001, ISO 27017, ISO 27018, ISO 27701, ISO 29151), CSA STAR, NIST CSF, BS10012 and KISMS, etc. We undertake to process relevant data under your authorization with appropriate security measures.<br /><br />

The website contains material that is owned by or licensed to us. This material includes, but is not limited to, the design, layout, look, appearance and graphics. Reproduction is prohibited without the express, written permission of jctrans.com/jctrans.net.<br /><br />

All trademarks reproduced in the websites, if any, which are not the property of, or licensed to the operator, are acknowledged on the websites.<br /><br />

In addition to other terms as set forth in the Agreement, you are prohibited from using the Website or its contents: (a) for any unlawful purpose; (b) to solicit others to perform or participate in any unlawful acts; (c) to violate any international, federal, provincial, or state regulations, rules, laws, or local ordinances; (d) to infringe upon or violate our intellectual property rights or the intellectual property rights of others; (e) to harass, abuse, insult, harm, defame, slander, disparage, intimidate, or discriminate based on gender, sexual orientation, religion, ethnicity, race, age, national origin, or disability; (f) to submit false or misleading information; (g) to upload or transmit viruses or any other type of malicious code that will or may be used in any way that will affect the functionality or operation of the Service or of any related website, other websites, or the Internet; (h) to collect or track the personal information of others; (i) to spam, phish, pharm, pretext, spider, crawl, or scrape; (j) for any obscene or immoral purpose; or (k) to interfere with or circumvent the security features of the Services or any related website, other websites, or the Internet. We reserve the right to terminate your use of the Services or any related website for violating any of the prohibited uses. Unauthorized use of the websites may give rise to a claim for damages and/or be a criminal offense.<br /><br />

Although this Website may be linked to other websites, we are not, directly or indirectly, implying any approval, association, sponsorship, endorsement, or affiliation with any linked website, unless specifically stated herein. We are not responsible for examining or evaluating, and we do not warrant the offerings of, any businesses or individuals or the content of their websites. We do not assume any responsibility or liability for the actions, products, services, and content of any other third parties. You should carefully review the legal statements and other conditions of use of any website which you access through a link from this Website. Your linking to any other off-site websites is at your own risk.<br /><br />

You may not create a link to the websites from another website or document without the express, prior written consent of jctrans.com/jctrans.net.<br /><br />

We perform regular backups of the Website and contents and will do our best to ensure the completeness and accuracy of these backups. In the event of hardware failure or data loss, we will restore backups automatically to minimize the impact and downtime.<br /><br />

You acknowledge that you have read this Agreement and agree to all its terms and conditions. By using the Website or its Services you agree to be bound by this Agreement. If you do not agree to abide by the terms of this Agreement, you are not authorized to use or access the Website and its Services.<br /><br />

If you have any questions about the terms and conditions, please contact us.`,
  register_agreement_content_old: `Welcome to our website. If you continue to browse and use the website, you are agreeing to comply with and be bounded by the following JCtrans terms and conditions, which are governed by Beijing JCtrans Network Co., Ltd.<br /><br />
  The term "you" refer to the user or viewer of our website. The viewer or user of this website is subject to the following terms and conditions.<br /><br />
  The content of the pages of the website is for your general information and use only. It is subject to change without notice. We reserve the right to modify this Agreement or its policies relating to the Website or Services at any time, effective upon posting of an updated version of this Agreement on the Website. Continued use of the Website after any such changes shall constitute your consent to such changes.<br /><br />
  Neither we nor any third parties provide any warranty or guarantee as to the accuracy, timelines, performance, completeness, or suitability of the information and materials found or offered on the websites for any particular purpose. You acknowledge that such information and materials may contain inaccuracies or errors and we expressly exclude liability for any such inaccuracies or errors to the fullest extent permitted by law. Occasionally there may be information on the Website that contains typographical errors, inaccuracies, or omissions that may relate to product descriptions, availability, promotions, and offers.<br /><br /> We reserve the right to correct any errors, inaccuracies, or omissions, and to change or update information or cancel orders if any information on the Website or on any related services is inaccurate at any time without prior notice (including after you have submitted your order). We undertake no obligation to update, amend or clarify information on the Website including, but not limited to, freight rate information, except as required by law. No specified update or refresh date applied on the Website should be taken to indicate that all information on the Website or on any related services has been modified or updated.<br /><br />
  Your use of any information or materials on the websites is entirely at your own risk, for which we shall not be liable. It shall be your own responsibility to ensure that any products, services, or information available through the websites meet your specific requirements. If you create an account on the Website, you are responsible for maintaining the security of your account and you are fully responsible for all activities that occur under the account and any other actions taken in connection with it. Providing false contact information of any kind may result in the termination of your account. You must immediately notify us of any unauthorized uses of your account or any other breaches of security. We will not be liable for any acts or omissions by you, including any damages of any kind incurred as a result of such acts or omissions. We may suspend, disable, or delete your account (or any part thereof) if we determine that you have violated any provision of this Agreement or that your conduct or content would tend to damage our reputation and goodwill. If we delete your account for the foregoing reasons, you may not re-register for our services. We may block your email address and internet protocol address to prevent further registration.<br /><br />
  You shall have sole responsibility for the accuracy, quality, integrity, legality, reliability, appropriateness, and intellectual property ownership or right to use of all submitted contents. We may monitor contents on the Website submitted or created using our Services by you. You grant us permission to access, copy, distribute, store, transmit, reformat, display, and perform the contents of your user account as required for the purpose of providing the Services to you. Without limiting any of those representations or warranties, we have the right, though not the obligation, to, in our own sole discretion, refuse or remove any content that, in our reasonable opinion, violates any of our policies or is in any way harmful or objectionable.<br /><br />
  If you decide to enable, access, or use third-party services, be advised that your access and use of such other services are governed solely by the terms and conditions of such other services, and we do not endorse, are not responsible or liable for, and make no representations as to any aspect of such other services, including, without limitation, their content or the manner in which they handle data (including your data) or any interaction between you and the provider of such other services. You irrevocably waive any claim against JCtrans with respect to such other services. JCtrans is not liable for any damage or loss caused or alleged to be caused by or in connection with your enablement, access, or use of any such other services, or your reliance on the privacy practices, data security processes, or other policies of such other services. You may be required to register for or log into such other services on their respective websites. By enabling any other services, you are expressly permitting JCtrans to disclose your data as necessary to facilitate the use or enablement of such other services.<br /><br />
  You agree that your use of our Website or Services is solely at your own risk. You agree that such Services is provided on an "as is" and "as available" basis. We expressly disclaim all warranties of any kind, whether express or implied, including but not limited to the implied warranties of merchantability, fitness for a particular purpose, and non-infringement. We make no warranty that the Services will meet your requirements, or that the Services will be uninterrupted, timely, secure, or error-free; nor do we make any warranty as to the results that may be obtained from the use of the Services or as to the accuracy or reliability of any information obtained through the Services or that defects in the Service will be corrected. You understand and agree that any material and/or data downloaded or otherwise obtained through the use of Services is done at your own discretion and risk and that you will be solely responsible for any damage to your computer system or loss of data that results from the download of such material and/or data. We make no warranty regarding any goods or services purchased or obtained through the Services or any transactions entered into through the Service. No advice or information, whether oral or written, obtained by you from us or through the Services shall create any warranty not expressly made herein.<br /><br />
  "Instant Messaging IM" is an application that provides users with online instant messaging based on the interface of "Tencent Cloud". For channel security and functional compliance, we will process personal information, including but not limited to information collection, storage, use, processing, transmission, etc. Please use the service under laws, regulations and policies. You take full responsibility for consequence arising from the illegal communications. This service has passed SOC series audit reports (SOC 1, SOC 2, SOC 3), cyber security protection 2.0 (level 3), ISO series certification (ISO 9001, ISO 20000, ISO 27001, ISO 27017, ISO 27018, ISO 27701, ISO 29151), CSA STAR, NIST CSF, BS10012 and KISMS, etc. We undertake to process relevant data under your authorization with appropriate security measures.<br /><br />
  The website contains material that is owned by or licensed to us. This material includes, but is not limited to, the design, layout, look, appearance and graphics. Reproduction is prohibited without the express, written permission of jctrans.com/jctrans.net.<br /><br />
  All trademarks reproduced in the websites, if any, which are not the property of, or licensed to the operator, are acknowledged on the websites.<br /><br />
  In addition to other terms as set forth in the Agreement, you are prohibited from using the Website or its contents: (a) for any unlawful purpose; (b) to solicit others to perform or participate in any unlawful acts; (c) to violate any international, federal, provincial, or state regulations, rules, laws, or local ordinances; (d) to infringe upon or violate our intellectual property rights or the intellectual property rights of others; (e) to harass, abuse, insult, harm, defame, slander, disparage, intimidate, or discriminate based on gender, sexual orientation, religion, ethnicity, race, age, national origin, or disability; (f) to submit false or misleading information; (g) to upload or transmit viruses or any other type of malicious code that will or may be used in any way that will affect the functionality or operation of the Service or of any related website, other websites, or the Internet; (h) to collect or track the personal information of others; (i) to spam, phish, pharm, pretext, spider, crawl, or scrape; (j) for any obscene or immoral purpose; or (k) to interfere with or circumvent the security features of the Services or any related website, other websites, or the Internet. We reserve the right to terminate your use of the Services or any related website for violating any of the prohibited uses. Unauthorized use of the websites may give rise to a claim for damages and/or be a criminal offense.<br /><br />
  Although this Website may be linked to other websites, we are not, directly or indirectly, implying any approval, association, sponsorship, endorsement, or affiliation with any linked website, unless specifically stated herein. We are not responsible for examining or evaluating, and we do not warrant the offerings of, any businesses or individuals or the content of their websites. We do not assume any responsibility or liability for the actions, products, services, and content of any other third parties. You should carefully review the legal statements and other conditions of use of any website which you access through a link from this Website. Your linking to any other off-site websites is at your own risk.<br /><br />
  You may not create a link to the websites from another website or document without the express, prior written consent of jctrans.com/jctrans.net.<br /><br />
  We perform regular backups of the Website and contents and will do our best to ensure the completeness and accuracy of these backups. In the event of hardware failure or data loss, we will restore backups automatically to minimize the impact and downtime.<br /><br />
  You acknowledge that you have read this Agreement and agree to all its terms and conditions. By using the Website or its Services you agree to be bound by this Agreement. If you do not agree to abide by the terms of this Agreement, you are not authorized to use or access the Website and its Services.<br /><br />
  If you have any questions about the terms and conditions, please contact us.`,
  register_police_content: `This privacy policy ("Policy") describes how jctrans.com/jctrans.net
  ("JCtrans", "we", "us" or "our") collects, protects, and uses the
  personally identifiable information ("Personal Information") you
  ("user", "you" or "your") may provide on the https://jctrans.com/jctrans.net
  website and any of its products or services (collectively, "Website"
  or "Services"). It also describes the choices available to you
  regarding our use of your personal information and how you can access
  and update this information. This Policy does not apply to the
  practices of companies that we do not own or control, or to
  individuals that we do not employ or manage.
  <br /><br />
  <span class="agreementDetail_title">
    Collection of personal information
  </span>
  <br /><br />
  We receive and store any information you knowingly provide to us when
  you create an account, publish content, fill out any online forms on
  the Website. When required this information may include your email
  address, name, phone number, address, or other Personal Information.
  You can choose not to provide us with certain information, but then
  you may not be able to take advantage of some of the Website's
  features.
  <br /><br />
  <span class="agreementDetail_title"
    >Collection of non-personal information</span
  >
  <br /><br />
  When you visit the Website our servers automatically record
  information that your browser sends. This data may include information
  such as your device's IP address, browser type, and version, operating
  system type and version, language preferences, or the webpage you were
  visiting before you came to our Website, pages of our Website that you
  visit, the time spent on those pages, the information you search for
  on our Website, access times and dates, and other statistics.
  <br /><br />
  <span class="agreementDetail_title"
    >Managing personal information</span
  >
  <br /><br />
  You are able to access, add to, update, and delete certain Personal
  Information about you. The information you can view, update, and
  delete may change as the Website or Services change. When you update
  information, however, we may maintain a copy of the unrevised
  information in our records. We will retain your information for as
  long as your account is active or as needed to provide you Services.
  Some information may remain in our private records after your deletion
  of such information from your account. We will retain and use your
  information as necessary to comply with our legal obligations, resolve
  disputes, and enforce our agreements. We may use any aggregated data
  derived from or incorporating your Personal Information after you
  update or delete it, but not in a manner that would identify you
  personally.
  <br /><br />
  <span class="agreementDetail_title"
    >Use of collected information</span
  >
  <br /><br />
  jctrans.com/jctrans.netas the Party Responsible for Data Handling, will handle
  your personal data for the following purposes: <br />
  1.Manage your registration as a Platform user, to identify you and
  give you access to Services available for registered Platform users.
  <br />2.Contact you through email regarding updates or information
  related to features, products, or services and updates, as long as
  they are needed or reasonable. <br />3.Respond to any request or
  inquiry you make through the customer service channels available on
  our Platform. <br />4.We also use your information to generate
  aggregated non-identifying data. For instance, generate statistics
  regarding our users, their jobs or areas of expertise, number of
  impressions or clicks in a specific project, or visitor demographics.
  <br /><br />
  Any of the information we collect from you may be used to personalize
  your experience, improve our Website, improve customer service, and
  run and operate our Website and Services. Non-personal information
  collected is used only to identify potential cases of abuse and
  establish statistical information regarding Website usage.
  <br /><br />
  <span class="agreementDetail_title">Newsletters</span>
  <br /><br />
  We offer electronic newsletters to which you may voluntarily subscribe
  at any time. You may choose to stop receiving our newsletter or
  marketing emails by following the unsubscribe instructions included in
  these emails or by contacting us. However, you will continue to
  receive essential transactional emails.
  <br /><br />
  <span class="agreementDetail_title">Cookies</span>
  <br /><br />
  The Website uses "cookies" to help personalize your online experience.
  A cookie is a text file that is placed on your hard disk by a web page
  server. Cookies cannot be used to run programs or deliver viruses to
  your computer. Cookies are uniquely assigned to you, and can only be
  read by a web server in the domain that issued the cookie to you. We
  may use cookies to collect, store, and track information for
  statistical purposes to operate our Website and Services. You have the
  ability to accept or decline cookies. Most web browsers automatically
  accept cookies, but you can usually modify your browser setting to
  decline cookies if you prefer.
  <br /><br />
  <span class="agreementDetail_title">Information security</span>
  <br /><br />
  We secure information you provide on computer servers in a controlled,
  secure environment, protected from unauthorized access, use, or
  disclosure. We maintain reasonable administrative, technical, and
  physical safeguards in an effort to protect against unauthorized
  access, use, modification, and disclosure of personal information in
  its control and custody. However, no data transmission over the
  Internet or wireless network can be guaranteed. Therefore, while we
  strive to protect your personal information, you acknowledge that (i)
  there are security and privacy limitations of the Internet which are
  beyond our control; (ii) the security, integrity, and privacy of any
  and all information and data exchanged between you and our Website
  cannot be guaranteed; and (iii) any such information and data may be
  viewed or tampered with in transit by a third-party, despite best
  efforts.
  <br /><br />
  In the event of a breach of security incident of personal information,
  we will activate an emergency response plan to prevent the expansion
  of such security incidents and inform you in the form of emails, push
  notifications, public announcements, etc. Meanwhile, we will provide
  you with suggestions on information security.
  <br /><br />
  Please keep your account and password information properly to avoid
  personal information leakage. jctrans.com/jctrans.net will be only responsible
  for the extent that the jctrans.com/jctrans.net platform or website directly
  leads to the disclosure of your personal information.
  <br /><br />
  <span class="agreementDetail_title">Data breach</span>
  <br /><br />
  In the event we become aware that the security of the Website has been
  compromised or users' Personal Information has been disclosed to
  unrelated third parties as a result of external activity, including,
  but not limited to, security attacks or fraud, we reserve the right to
  take reasonably appropriate measures, including, but not limited to,
  investigation and reporting, as well as notification to and
  cooperation with law enforcement authorities. In the event of a data
  breach, we will make reasonable efforts to notify affected individuals
  if we believe that there is a reasonable risk of harm to the user as a
  result of the breach or if notice is otherwise required by law. When
  we do we will post a notice on the Website, send you an email.
  <br /><br />
  <span class="agreementDetail_title">Legal disclosure</span>
  <br /><br />
  We will disclose any information we collect, use or receive if
  required or permitted by law, such as to comply with a subpoena or
  similar legal process, and when we believe in good faith that
  disclosure is necessary to protect our rights, protect your safety or
  the safety of others, investigate fraud, or respond to a government
  request. In the event we go through a business transition, such as a
  merger or acquisition by another company, or sale of all or a portion
  of its assets, your user account, and personal data will likely be
  among the assets transferred.
  <br /><br />
  <span class="agreementDetail_title">Changes and amendments</span>
  <br /><br />
  We reserve the right to modify this privacy policy relating to the
  Website or Services at any time, effective upon posting of an updated
  version of this Policy on the Website. Continued use of the Website
  after any such changes shall constitute your consent to such changes.
  <br /><br />
  <span class="agreementDetail_title">Acceptance of this policy</span>
  <br /><br />
  You acknowledge that you have read this Policy and agree to all its
  terms and conditions. By using the Website or its Services you agree
  to be bound by this Policy. If you do not agree to abide by the terms
  of this Policy, you are not authorized to use or access the Website
  and its Services.
  <br /><br />
  <span class="agreementDetail_title">Contacting us</span>
  <br /><br />
  If you have any questions about this Policy, please contact us.`,
  // newRegister
  n_Register_Password: 'Password',
  n_register_qyz: "We've sent Verification Code to",
  n_register_qyz2:
    'To continue using the inquiry system, please verify your email address.',
  n_register_manual: 'Please try the following steps:',
  n_register_manual2:
    '1. Please check your spam folder as it is very common to have email delivery problems because of automated filters.',
  n_register_manual3:
    '2. Please take a rest. It may take a few minutes to receive the email.',
  n_register_manual4:
    "3. If you're having trouble with receiving the email, please contact us.",
  n_register_contact_us: 'Contact us',
  n_register_code: 'Select',
  n_register_phone: 'Please enter your cell phone number',
  n_register_phone1: 'Cell Phone Number',
  n_register_new: 'New User Registration',
  n_register_Wel: 'Welcome to JCtrans!',
  n_register_Join: 'Real Service Real Business',
  register_label_email: 'Email Address',
  register_label_cell: 'Cell Phone Number',
  register_valid_areaCode: 'Area code is required',
  register_repeat_companyName:
    'The company already exists, please contact customer service',
  bindCompany_tip: 'Please complete the company information',
  bindCompany_confirm: 'Complete and enter',

  // 修改密码
  changePass_title: 'Change password',
  old_pwd_verify: 'Old Password Verification',
  email_verify: 'Email Verification',
  mobile_verify: 'Phone Verification',

  changePass_success: 'Change Password successfully',
  changePass_content: 'Password strength is weak, please try another one',
  register_UserName_FNP_null:
    'Username can not be empty, please enter the username.',
  changePass_cpLabel: 'Current Password',
  changePass_npLabel: 'New Password',
  changePass_conpLabel: 'Confirm Password',
  changePass_npassPlaceholder:
    '6-20 characters include letters, numbers and symbols',
  // 滑动验证
  verification_title: 'please finish the security verification',
  verification_explain: 'swipe right to complete the picture puzzle',
  verification_failed: 'verification failed',
  verification_success: 'verified successfully',
  // 邮件退订
  emailC_title:
    'Are you sure you want to unsubscribe? If so, you will no longer receive notifications from JCtrans.',
  emailC_email_message: 'Please input Activity email',
  emailC_mail: 'Unsubscribed email',
  emailC_type: 'Type of unsubscription',
  emailC_type1: 'Daily inquiry email notifications of subscribed locations',
  emailC_type_message: 'Please select the type of unsubscription',
  emailC_reason: 'Reason for unsubscription',
  emailC_reason1: 'Too many notification emails, really bothers me',
  emailC_reason2: 'The timing of the notification emails is troubling me',
  emailC_reason3: 'Email subject is obscure, no specified contents',
  emailC_reason4: 'Useless email contents',
  emailC_reason5: 'Incorrect email format',
  emailC_reason6: 'Other reasons',
  emailC_Submit: 'Confirm to unsubscribe',
  emailC_reasons_message: 'Please select the reason for unsubsciption',
  emailC_success: 'Unsubscribe succeeded !',
  emailC_otherR_error: "Please don't leave other reason blank",

  // 企业信息-企业账号
  companyAccount_title: 'Company Account',
  company_account_sort: 'Serial Number',
  company_account_account: 'Username',
  company_account_cn_name: 'Chinese Name',
  company_account_en_name: 'English Name',
  company_account_en_name_En: 'Name',
  company_account_type: 'Status',
  company_account_position: 'IM Customer Service',
  company_account_action: 'Operate',
  company_account_action_success: 'Operation successful',
  company_account_add_success: 'Added successfully',
  company_account_edit_success: 'Edit successfully',
  company_account_setMain_tips:
    'Do you confirm the transfer of the primary account rights?',
  company_account_setMain_content_prefix: 'set ',
  company_account_setMain_content_suffix: ' as the main account of the company',
  company_Master_account: 'Primary Account',
  company_Sub_account: 'Sub account',
  setup_phone: 'Cell Phone',
  company_setting_edit: 'Edit',
  company_setting_del: 'Delete',
  company_setting_del_title: 'Confirm to delete?',
  company_setting_del_tips1: 'The sub-account',
  company_setting_del_tips2: 'cannot be restored after being deleted !',
  company_account_del_success: 'Delete success',
  company_setting_resetPass_title:
    'Do you confirm to reset the password of the account?',
  company_setting_resetPass_tips1: 'The reset password will be sent to ',
  company_account_resetPass_success: 'Password reset succeeded',
  company_setting_reason: 'Reason',
  company_setting_reason_title: 'Reason for deactivation',
  company_setting_more: 'More',
  company_setting_Master: 'Set to Main Account',
  company_setting_resetPass: 'Reset Password',
  company_setting_customerService: 'Set as IM Customer Service',
  company_add_son: 'Create Sub-account',
  company_edit_son: 'Edit Sub-account',
  company_header_tips:
    'A maximum of nine sub-accounts can be created by members',
  company_header_tips2:
    'A maximum of four sub-accounts can be created by members',
  company_header_tips3:
    'A maximum of fifteen sub-accounts can be created by JCE members',
  setup_Send: 'Send',
  sAccount_status_audit: 'Auditing',
  sAccount_status_disable: 'Disable',
  sAccount_status_normal: 'Normal',
  company_account_kf: '',

  // 企业账号-验证弹框
  verify_own_operation: 'Please verify your identity to make sure it is you',
  verify_Verification_Code: 'Verification Code',
  verify_enter_code: 'Please enter a four digit verification code',
  verify_Mailbox_cannot: `Email is out of service. Contact `,
  verify_Contact_service: `customer service`,
  verify_Submit_validation: 'Submit',
  setup_Resend: 'Resend',
  verify_send_success: 'Sent successfully',
  verify_code_format_error: 'Verification code format error',
  placeholder_code: 'Please Enter the Verification Code',

  // 企业账号-子账号表单
  sonAccount_account_ph: '6-30 characters include letters or numbers',
  sonAccount_nameCn_ph: 'Please enter your full name in chinese',
  sonAccount_nameEn_ph: 'Please enter your full name in english',
  sonAccount_mobile_ph: 'Please enter phone number',
  sonAccount_email_ph: 'Eg. Email@jctrans.net',
  sonAccount_passwd_ph: '6-20 characters include letters and numbers',
  sonAccount_currentPass_ph: '6-20 characters include letters and numbers',
  setup_cancel: 'Cancel',
  company_account_sNumMax_tips:
    'The number of your sub-accounts has reached the limit, please contact customer service to purchase more.',
  company_account_sNumMax_tips_noVip:
    'Non-member can set 5 accounts maximum, become paid member to set more',
  company_validateComName_btn: 'customer service',
  sonAccount_account_r1: 'Username can not be empty, please enter the username',
  sonAccount_account_r2:
    'Username must be between 6-30 characters include letters or numbers',
  sonAccount_nameCn_r1: 'Please enter your full name in chinese',
  sonAccount_nameEn_r1: 'Please enter your full name in english',
  sonAccount_nameEn_r2: 'Do not include Chinese characters in English Name',
  sonAccount_mobile_r1: 'Please enter your cell phone',
  sonAccount_mobile_r2: 'Please enter the correct phone number',
  sonAccount_email_r1: 'Email address is required',
  sonAccount_email_r2: 'Please enter a valid email address',
  sonAccount_passwd_r1: 'Password can not be empty, please enter the password',
  sonAccount_passwd_r2:
    'The password must be at 6-20 characters include letters and numbers',
  sonAccount_currentPass_r1:
    'Password can not be empty, please enter the password',
  sonAccount_currentPass_r2:
    'The password must be at 6-20 characters include letters and numbers',
  sonAccount_currentPass_r3:
    'Password mismatch, please make sure your passwords match',
  personal_tips_addsubmit: 'Confirm to add sub account?',
  personal_tips_editsubmit:
    'Are you sure to update the sub account information?',
  areaCode_require: 'Please select',
  // 企业账号表单label
  sonAccount_account_label: 'Username',
  sonAccount_nameCn_label: 'Chinese Name',
  sonAccount_nameEn_label: 'English Name',
  sonAccount_mobile_label: 'Cell Phone',
  sonAccount_email_label: 'Email',
  sonAccount_passwd_label: 'Password',
  sonAccount_currentPass_label: 'Confirm Password',

  // 独立注册链接
  Independent_registration_username: 'Please enter 6-30 letters or numbers',
  Independent_registration_password:
    '6-20 characters include letters, numbers and symbols',
  Independent_registration_confirmPassword: 'Please enter the same password',
  Independent_registration_email: 'Email address is required',
  Independent_registration_email2: 'Please enter the correct email address',
  Independent_registration_companyNameCh_p:
    'Please enter your company name in Chinese',
  Independent_registration_companyNameCh:
    'Please enter the correct company name in Chinese',
  Independent_registration_companyNameEn_p:
    'Please enter your company name in English',
  Independent_registration_companyNameEn:
    'Please enter the correct company name in English',
  Independent_registration_ChineseName_p:
    'Please enter your company name in Chinese',
  Independent_registration_ChineseName:
    'Please enter your correct Chinese name',
  Independent_registration_EnglishName_p: 'Please enter your English name',
  Independent_registration_EnglishName:
    'Please enter your correct English name',
  Independent_registration_CellPhone_p: 'Please enter your cell phone number',
  Independent_registration_CellPhone:
    'Please enter your correct cell phone number',
  Independent_registration_verificationCode:
    'Please enter the correct verification code',
  Independent_registration_JobTitle:
    'Please enter the correct job title in English',
  Independent_registration_CompanyLogo: 'Please upload Company Logo',
  Independent_registration_DataOfEstablishment:
    'Please enter the year in which your company was established',

  Independent_registration_ConfirmInfo1: 'Please confirm to submit',
  Independent_registration_ConfirmInfo2:
    'If you click"yes", your form will be submitted and no other changes can be made.',
  Independent_registration_ConfirmInfo_Yes: 'Yes',
  Independent_registration_ConfirmInfo_No: 'No',
  Independent_registration_min2: 'At least two characters',

  // 上传公司 logo
  upload_form_logo_upload: 'upload',
  upload_form_logo_submit: 'submit',
  upload_form_logo_submit_success: 'uploaded successfully',
  upload_form_logo_submit_error:
    'The doc format is error, please upload picture with jpg/png format.',
  upload_form_logo_submit_error2:
    'The picture is too large, try again or contact us',
  // JCYS-1829
  invite_member: 'Invite members to join',
  invite_member_company: 'Invite members to join the company',
  invite_copy_link:
    'Copy the invitation link, register and join the current company directly:',
  invite_copy: 'Copy',
  invite_examine:
    'After applying to join your company, you need to review and confirm',
  join_company: 'Application for joining your company',
  join_company_tips:
    'There is currently an account applying to join your company. Please confirm whether you agree to join. After agreeing to join, the account will become a sub-account under your company:',
  join_agree: 'Agree to join your company',
  join_refuse: 'Disagree',
  join_user_name: 'Name',
  join_email: 'Email',
  join_mobile: 'Cell Phone',
  examine: 'Review',
  join_company_again_sure:
    'Please confirm whether you agree to this account joining your company. After joining, you can use it to view all information under the company.',
  join_company_again_cancel:
    'Please confirm whether to reject this account from joining your company?',

  register_already_tip:
    'The company already exists. Would you like to apply to ',
  register_join_in: 'join in >>',
  register_already_join: 'Company Name In English',
  register_already_company: 'Company location (City)',
  register_name_en: 'Your English Name：',
  register_name_cn: 'Your Chinese Name：',
  register_name_placeholder: 'Please enter your name to prove your identity',
  register_name_tips1: 'please enter your Chinese name',
  register_name_tips2:
    'Only Chinese and English characters and symbols can be entered, with a maximum of 50 words.',
  register_name_tips3: 'Please enter your English name',
  register_name_tips4:
    'Only English characters and symbols can be entered, up to 50 words.',
  register_modify: 'Change',
  register_first_name_p: 'First Name',
  register_last_name_p: 'Last Name',

  copy_success: 'Successful replication',
  copy_error: 'Replication failure',

  thirdParty: {
    bind_title: 'You already have an account, select an account to bind',
    bind_cancel: 'Cancel',
    bind_confirm: 'Select',
    sign_up: 'Sign up and bind',
    sign_up_and_login: 'Sign up and log in',
    login_and_bind: 'Sign in and bind',
    click_to_bind: 'To bind',
    email_has_been_registered: 'This email has been registered',
    mobile_has_been_registered: 'This phone number has been registered',
    bind_login_title: 'You already have an account, log in to bind',

    sign_in_with: 'Sign in with',
    wechat: 'WeChat',
    facebook: 'Facebook',
    google: 'Google',
    linkedin: 'LinkedIn',

    back: 'Back',

    password: 'Password',
    verify_password: 'Verify Password',
    email: 'Email',
    mobile: 'Cell Phone',
    verify_code: 'Verification Code',

    account: 'Account',
    back_to_form:'Verification Code Login',
    user_has_other_bind:
      'The account has been bound to another account, please change your account',
  },
}
